import common from './common'
import featuresPay from './feature'

const zh_HK = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "產品/變體",
        serialNumber: "序號",
        noProductsFound: "未找到產品",
        searchByProductSku: "按產品/SKU搜尋",
        searchSerialNumbers: "搜尋序號",
        transactionDetails: "交易詳情",
        notAvailable: "不適用",
        mainWarehouse: "主倉庫"
    },
    new_build_banner: {
        title: '新版本:',
        is_available: '現已發佈',
        fallback_title: '應用程式有新版本可用',
        desc: '重新整理以獲取最新功能和改進。',
        refreshing: '正在重新整理…',
        refresh_now: '立即重新整理',
        later: '稍後',
        you_are_on: "您目前使用的是"
    },
    short: {
        finance: '財務',
        stock: '存貨'
    },
    onboarding: {
        welcome: '歡迎！',
        step: {
            product: {
                totalBreakdown: '總明細',
                overallFulfilment: '整體履行情況',
                totalShippedQty: '總發貨數量',
                totalReceivedQty: '總接收數量',
                totalOrderedQty: '總訂購數量',
                totalShippedOrdered: '總發貨 / 訂購',
                totalReceivedOrdered: '總接收 / 訂購',
                viewQty: '查看數量',
                fetchingQty: '正在獲取數量詳情...',
                noStockInfo: '未找到庫存資訊',
                title: '已完成 65%',
                description: '只剩 2 步驟，即可開啟您嘅成功之旅！',
                Warehouse: "倉庫",
            },
            stock: {
                title: '已完成 95% 快搞掂！！',
                description: '只剩一步！即刻完成，開始您嘅成功之旅！'
            }
        },
        business: {
            title: '業務建立成功！',
            description: '太好了！您的業務已經成功註冊'
        },
        product: {
            title: '新增您的第一個產品',
            description: '新增產品開始記錄存貨',
            Warehouse: "倉庫",
        },
        stock: {
            title: '試下新增存貨',
            description: '開始記錄貨品入貨同出貨'
        },
        action: {
            add_business: {
                title: '建立新業務',
                description: '想開新業務？喺度按一下'
            },
            join_business: {
                title: '加入業務',
                description: '有邀請碼？喺度加入'
            }
        }
    },
    business: {
        title: '揀選業務、新建或加入',
        add_business: {
            title: '建立新業務',
            name: '業務名稱',
            name_placeholder: '輸入名稱',
            category: '業務類別',
            category_placeholder: '揀選類別',
            button: '建立業務'
        },
        edit_business: {
            title: '編輯業務'
        },
        join_business: {
            title: '加入業務',
            input_code: '喺下面輸入邀請碼：',
            field_placeholder: '邀請碼',
            confirm_title: '加入',
            confirm_text: '您將成為 '
        },
        no_business: '暫無業務',
        create_or_join: '建立或加入業務',
        message: {
            saved: '業務儲存成功！'
        },
        settings: {
            isNegativeTransactionDisabled: '負庫存交易',
            isNegativeTransactionDisabledHint: '開啟此功能後，您可以防止導致庫存變為負數的交易。',
            negativeStockError: '負庫存交易已禁用'
        }
    },
    profile: {
        edit_profile: {
            title: '編輯個人資料',
            name: '全名',
            name_placeholder: '輸入全名',
            email: '電郵',
            phone_number: '電話號碼'
        },
        message: {
            required_name: '姓名係必填'
        }
    },
    product: {
        weightedAverageCost: '加權平均成本',
        weightedAverageValueLabel: '加權平均值',
        Product: '產品',
        hideZeroStock: '隱藏零庫存',
        allVariants: '所有款式',
        choose_product: '揀選產品',
        choose_product_empty: '請揀選產品並輸入數量',
        choose_product_empty_manufacturing: '請揀選產品並輸入製造數量',
        search: {
            placeholder: '按名稱搜尋',
            tooltip: '開啟掃描器',
            Warehouse: "倉庫",
        },
        column: {
            image: '相片',
            name: '名稱',
            price: '售價',
            buying_price: '成本價',
            selling_price: '售價',
            sku: '產品編號',
            stock: '存貨',
            quantity: '數量',
            latest_stock: '結餘',
            product_deleted: '產品已被刪除',
            info_not_found: '資料暫時未能顯示',
            expired_date: '到期日',
            invoice: '發票'
        },
        no_product: '暫無產品',
        no_product_subtitle: '添加您的第一個產品以開始跟踪庫存、價格和銷售。',
        create_first_product: '創建您的第一個產品',
        add_product: {
            sku: '產品編號',
            sku_placeholder: '產品編號，例如：12345',
            name: '產品名稱',
            name_placeholder: '輸入產品名稱',
            initial_stock: '初始存貨',
            initial_stock_placeholder: '輸入初始存貨',
            buying_price: '成本價',
            buying_price_placeholder: '輸入成本價',
            selling_price: '售價',
            selling_price_placeholder: '輸入售價',
            category: '類別',
            category_placeholder: '揀選類別',
            add_selling_price: '新增批發價',
            expired_date: '到期日',
            expired_date_placeholder: '揀選日期',
            description: '描述',
            description_placeholder: '輸入描述',
            custom_label: '自訂屬性',
            custom_label_placeholder: '輸入鍵名',
            add_custom_label: '新增更多屬性',
            Warehouse: "倉庫",
        },
        customerLabel: {},
        choose_selling_price: '揀選售價',
        selling_price: '售價',
        total_product: '產品總數',
        total_quantity: '總存貨量',
        total_buying_price: '總成本價',
        total_selling_price: '總售價',
        message: {
            required_name: '產品名稱係必填',
            required_sku: '產品編號係必填',
            required_category: '類別係必填',
            required_quantity: '初始存貨係必填',
            invalid_input_qty: '存貨數量無效',
            required_buying_price: '成本價係必填',
            required_selling_price: '售價係必填',
            required_selling_price_name: '售價名稱係必填',
            required_selling_price_price: '售價金額係必填'
        },
        viewMore: '查看更多',
        WarehouseDetails: '倉庫詳情',
        WarehouseName: '倉庫名稱',
        AddWarehouse: '新增倉庫',
        WarehouseQty: '倉庫數量',
        Warehouse: '倉庫',
        Warehouses: '倉庫',
        Variants: '變體',
        VariantName: '變體名稱',
        productVariant: '產品變體',
        AddVariant: '新增變體',
        TranferItem: '轉移貨品',
        AddUnit: '新增單位',
        InitialStkWarehouse: '新增變體前需要設定初始倉庫存貨',
        InitialStockinwarehouse: '倉庫初始存貨',
        TotalQuantity: '總數量：',
        AddNote: '新增備註（成本價）',
        AddNotetitle: '新增備註',
        VariantSuccessMessage: '產品變體更新成功',
        Next: '下一步',
        Submit: '提交',
        INACTIVE: '未啟用',
        errorone: '哎呀！要求嘅數量',
        errortwo: '同已分配嘅倉庫數量唔匹配。請調整數量或補貨。',
        SelectWarehouse: '揀選倉庫',
        SelectVariant: '揀選變體',
        Discount: '折扣',
        DiscountDetails: '折扣詳情',
        FinalPrice: '最終售價',
        DiscountType: '折扣類型',
        DiscountPer: '折扣百分比',
        DiscountValue: '折扣金額',
        Discountonprice: '直接減價',
        Discountondiscount: '再減折扣',
        AdditionalDiscount: '額外折扣',
        SellingPrice: '售價：',
        Save: '儲存',
        OnOriginalPrice: '原價計算',
        OnDiscountedPrice: '已折扣價計算',
        columnSelector: {
            title: '顯示列',
            columnsButton: '列',
            costPrice: '成本價',
            sellingPrice: '銷售價',
            sku: 'SKU',
            warehouse: '倉庫',
            categories: '分類',
            safetyStock: '安全庫存',
            attributes: '屬性',
            notes: '備註',
            description: '描述',
            more: '更多',
            attribute: '屬性',
            attributesTitle: '屬性',
            categoriesTitle: '分類',
            skuAliases: 'SKU 別名'
        }
    },
    note: {
        title: '備註',
        add: '新增備註',
        no_note: '暫無備註'
    },
    settings: {
        category: '類別',
        language: '語言',
        switch_business: '切換業務',
        currencySelect: '貨幣',
        languageChangeSuccess: '貨幣更新成功',
        languageChangeErrorMessage: '更新貨幣時發生錯誤',
        currencyAdded: "貨幣新增成功",
        currencyDelete: "貨幣刪除成功",
        Selectyourpreferredlanguage: "選擇您偏好的語言",
    },
    selectProductStock: '揀選產品',
    category: {
        category_list: {
            title: '產品類別'
        },
        add_category: {
            button: '新增類別',
            title: '新增類別'
        },
        edit_category: {
            title: '編輯類別'
        },
        name: '類別名稱',
        name_placeholder: '輸入類別名稱',
        no_category: '暫無類別'
    },
    staff: {
        add: '新增員工',
        edit: '編輯員工',
        access: {
            stock: '存貨',
            add_product: '新增產品',
            edit_product: '編輯產品',
            delete_product: '刪除產品',
            view_capital_price: '查看成本價',
            add_category: '新增類別',
            edit_category: '編輯類別',
            delete_category: '刪除類別',
            add_supplier: '新增供應商',
            edit_supplier: '編輯供應商',
            delete_supplier: '刪除供應商',
            add_customer: '新增客戶',
            edit_customer: '編輯客戶',
            delete_customer: '刪除客戶',
            add_staff: '新增員工',
            edit_staff: '編輯員工',
            delete_staff: '刪除員工',
            change_business_profile: '更改業務資料',
            access_by_product_category: '按產品類別存取',
            no_category_message: '您未有任何類別，請先新增類別。',
            expenses: '開支',
            view_expenses: '查看開支',
            add_expenses: '新增開支',
            edit_expenses: '編輯開支',
            delete_expenses: '刪除開支',
            warehouse: '倉庫',
            add_new_warehouse: '新增倉庫',
            edit_warehouse: '編輯倉庫',
            delete_warehouse: '刪除倉庫',
            transfer_warehouse: '倉庫轉移',
            transfer_warehouse_approval: '倉庫轉移審批',
            access_by_warehouse: '按倉庫存取',
            no_warehouse_message: '您未有任何倉庫，請先新增倉庫。',
            purchase_order: "採購訂單",
            purchase_order_creation: "採購訂單建立",
            purchase_order_edit: "採購訂單編輯",
            purchase_order_cancel: "採購訂單取消",
            purchase_order_reopen: "採購訂單重新開啟",
            purchase_order_receive: "採購訂單接收",
            sales_order: "銷售訂單",
            sales_order_creation: "銷售訂單建立",
            sales_order_edit: "銷售訂單編輯",
            sales_order_cancel: "銷售訂單取消",
            sales_order_reopen: "銷售訂單重新開啟",
            sales_order_receive: "銷售訂單已出貨",
            purchase_order_approval: "採購訂單審批",
            sales_order_approval: "銷售訂單審批",
            can_do_available_warehouse: "可用倉庫",
            add_batch: "批次建立審批"
            ,
            notification: '通知',
            staffNotification: '啟用通知',
            assignee: "負責人",
        },
        no_staff: '暫無員工。'
    },
    code: {
        title: '成功新增員工！',
        subtitle: '分享以下邀請碼畀佢加入：',
        valid: '此碼只有效 48 小時',
        share: '分享到 WhatsApp',
        copied: '已複製！',
        invalid: '無效嘅邀請碼！'
    },
    history: {
        no_history: '暫無記錄。',
        detail: {
            remove: '移除記錄',
            confirm: '呢個功能會影響現有存貨、歷史記錄同報表。'
        },
        no_history_selected: "未選擇任何歷史記錄",
        select_history_hint: "點擊列表中的歷史記錄以查看詳細資料",
        select_from_left: "從左側面板選擇",
    },
    supplier: {
        add: {
            title: '新增供應商'
        },
        edit: {
            title: '編輯供應商'
        },
        new: '新供應商',
        no_supplier: '暫無供應商。',
        bank: {
            title: '銀行資料'
        },
        note: '備註',
        form: {
            name: {
                label: '供應商名稱',
                placeholder: '輸入供應商名稱',
                placheolder_not_mandatory: '輸入名稱',
                error: {
                    required: '名稱唔可以留空'
                }
            },
            contact: {
                label: '聯絡電話',
                placeholder: '91934554432',
                error: {
                    required: '聯絡電話唔可以留空',
                    invalid: '號碼無效，請包括國家代碼'
                }
            },
            bank_name: {
                label: '銀行名稱',
                placeholder: '輸入銀行名稱'
            },
            bank_account_name: {
                label: '戶口持有人姓名',
                placeholder: '輸入戶口持有人姓名'
            },
            bank_account_number: {
                label: '銀行戶口號碼',
                placeholder: '輸入戶口號碼'
            },
            note: {
                label: '備註',
                placeholder: '新增備註'
            },
            openingBalance: {
                addBtn: '新增期初餘額',
                label: '期初餘額',
                placeholder: '輸入期初餘額',
                error: {
                    negative: '期初餘額不能為負數'
                }
            }
        },
        choose: '揀選供應商'
    },
    customer: {
        add: {
            title: '新增客戶'
        },
        edit: {
            title: '編輯客戶'
        },
        new: '新客戶',
        no_customer: '暫無客戶。',
        note: '備註',
        form: {
            name: {
                label: '客戶名稱',
                placeholder: '輸入客戶名稱',
                placheolder_not_mandatory: '輸入名稱',
                error: {
                    required: '名稱唔可以留空'
                }
            },
            contact: {
                label: '聯絡電話',
                placeholder: '91934554432',
                error: {
                    required: '聯絡電話唔可以留空',
                    invalid: '號碼無效，請包括國家代碼'
                }
            },
            address: {
                label: '地址',
                placeholder: '輸入地址'
            },
            note: {
                label: '備註',
                placeholder: '新增備註'
            },
            openingBalance: {
                addBtn: '新增期初餘額',
                label: '期初餘額',
                placeholder: '輸入期初餘額',
                error: {
                    negative: '期初餘額不能為負數'
                }
            }
        },
        choose: "選擇客戶",
        report: {
            view: '查看買家報表',
            title: '客戶報表',
            no_report: '所選日期冇買家嘅報表資料。',
            column: {
                name: '名稱',
                total_transaction: '總交易次數',
                total_amount: '總銷售額',
                total_profit: '總利潤'
            }
        }
    },
    confirm_delete: '您確定要刪除呢筆資料？',
    report: {
        title: '報表'
    },
    accounting: {
        download_pdf_report: '下載PDF',
        title: '會計',
        view_report: '查看財務報表',
        dashboard_title: '財務報表',
        stats: '統計數據',
        accounting_report: '會計報表',
        filter: {
            date: {
                placeholder: '揀選日期',
                submit: '套用',
                cancel: '重設篩選'
            },
            timeframe: {
                day: '每日',
                week: '每週',
                month: '每月',
                year: '每年'
            }
        },
        total_sales: '總銷售額',
        total_purchases: '總採購額',
        total_profit: '總利潤',
        total_expenses: '總開支',
        assets_value: '現有資產價值',
        total_current_cogs_value: '當前總COGS價值',
        current_asset_selling_price: '當前資產售價',
        total_selling_price: '總售價',
        table: {
            date: '日期',
            sales: '銷售',
            purchases: '採購',
            profit: '利潤',
            expenses: '開支'
        },
        no_data: '暫無資料。'
    },
    stock_report: {
        title: '存貨報表',
        view: '查看存貨報表',
        no_report: '所選日期或員工冇存貨記錄。',
        allStaffPlaceHolder: '所有員工',
        column: {
            total_product: '現有產品種類',
            total_product_quantity: '現有產品總數量'
        }
    },
    subscription: {
        paywall_small: {
            title: 'VIP 功能',
            description:
                '您嘅試用期已結束。請訂閱支持呢個本地應用程式嘅持續開發。',
            button: '查看訂閱計劃'
        }
    },
    payment: {
        order: {
            title: '付款'
        }
    },
    imageUploadMessage: {
        uploadSize: '圖片大小唔可以超過 5MB！',
        failedMessage: '上載貨品圖片失敗，請再試一次！',
        successUpload: '圖片上載成功！',
        failedUIError: '刪除圖片失敗，請再試一次！',
        SuccessErrorImage: '圖片已成功刪除！'
    },
    productColumns: {
        SKULabel: '產品編號',
        nameLabel: '產品名稱',
        categoryLabel: '類別',
        BuyingPriceLabel: '成本價',
        SellingLabel: '售價',
        StockLabel: '存貨'
    },
    historyColumns: {
        Transactionlabel: '交易類型',
        Locallabel: '本地時間',
        Createdlabel: '建立者',
        Vendorlabel: '供應商名稱',
        Buyerlabel: '買家名稱',
        SKUlabel: '產品編號',
        Invoicelabel: '發票',
        Productlabel: '產品名稱',
        Categorylabel: '類別',
        Buyinglabel: '成本價',
        Sellinglabel: '售價',
        Initiallabel: '初始存貨',
        Finallabel: '最終存貨',
        Stocklabel: '存貨變動'
    },
    stockReportColumns: {
        skuLabel: '產品編號',
        productNameLabel: '產品名稱',
        categoryLabel: '類別',
        buyingPriceLabel: '成本價',
        sellingPriceLabel: '售價',
        stockInLabel: '入貨',
        stockOutLabel: '出貨',
        remainingStockLabel: '剩餘存貨',
        openStockLabel: '初始存貨',
        weightedAverageCost: '加權平均成本',
        weightedAverageCostLabel: '加權平均成本',
        weightedAverageValueLabel: '加權平均值'
    },
    accountingReportColumns: {
        dateRange: '日期範圍',
        reportingPeriod: '報告期間',
        reportGenerate: '報告生成',
        warehouse: '倉庫',
        labelDate: '日期',
        labelSales: '銷售',
        labelPurchases: '採購',
        labelProfit: '利潤',
        labelExpenses: '支出',
        reportOptions: '報告列',
        summaryCards: '摘要卡片',
        grandTotal: '總計',
        continued: '續',
        subtotal: '小計',
        page: '頁'
    },
    customerReportColumns: {
        labelName: '名稱',
        labelTotalTransaction: '總交易次數',
        labelTotalSales: '總銷售額',
        labelTotalProfit: '總利潤'
    },
    scannerDialog: {
        finished: '完成',
        reduce: '減少',
        successfull: '成功',
        searching: '搜尋緊...',
        title: '掃描器已啟動。請對準條碼！'
    },
    historyFilter: {
        SelectBuyer: '揀選買家',
        SelectVendor: '揀選供應商'
    },
    productStockFilter: {
        StockLowtoHigh: '存貨由少到多',
        StockHightoLow: '存貨由多到少',
        AlphabetAZ: '字母 A-Z',
        AlphabetZA: '字母 Z-A'
    },
    minimizeTitle: '掃描器運作緊',
    security_guarantee: {
        title: '資料安全有保證'
    },
    invoice: {
        invoicePlaceholder: '發票號碼',
        invoiceTitle: '發票',
        manageInvoiceAddress: '管理發票地址',
        selectOrManageAddresses: '選擇、編輯或建立自訂發票地址',
        useBusinessProfileAddress: '使用商業檔案地址',
        noCustomAddressesFound: '未新增自訂地址',
        createCustomAddressDesc: '新增自訂帳單或分支機構地址以列印在發票上，替代預設的商業檔案資料。',
        defaultFromBusinessProfile: '商業檔案預設',
        editInvoiceAddress: '編輯發票地址',
        createNewInvoiceAddress: '建立新發票地址',
        logoHeaderImage: '標誌 / 頁首圖片',
        deleteInvoiceAddress: '刪除發票地址？',
        deleteAddressConfirmText: '確定要刪除此發票地址嗎？此操作無法撤銷。'
    },
    ManageInvoiceAddress: '管理發票地址',
    SelectOrManageAddresses: '選擇、編輯或建立自訂發票地址',
    UseBusinessProfileAddress: '使用商業檔案地址',
    CreateNewAddress: '建立新地址',
    UpdatingList: '正在更新列表...',
    NoCustomAddressesFound: '未新增自訂地址',
    CreateCustomAddressDesc: '新增自訂帳單或分支機構地址以列印在發票上，替代預設的商業檔案資料。',
    DefaultFromBusinessProfile: '商業檔案預設',
    EditInvoiceAddress: '編輯發票地址',
    CreateNewInvoiceAddress: '建立新發票地址',
    LogoHeaderImage: '標誌 / 頁首圖片',
    UploadingImage: '正在上傳圖片...',
    UploadImage: '上傳圖片',
    BusinessName: '企業名稱',
    AddressDetails: '地址詳情',
    PhoneNumber: '電話號碼',
    EmailAddress: '電子郵件地址',
    DeleteInvoiceAddress: '刪除發票地址？',
    DeleteAddressConfirmText: '確定要刪除此發票地址嗎？此操作無法撤銷。',

    stocklowreport: {
        no_stocklowreport_one: '暫無設定安全存量嘅貨品。',
        no_stocklowreport_two: '請為貨品新增安全存量數量。',
        currentStock: '目前庫存',
        safetyStock: '安全庫存',
        pricing: '定價',
        costPrice: '成本價',
        sellingPrice: '售價',
        productInfo: '產品資料',
        category: '類別',
        description: '描述',
        no_description: '尚未新增描述',
        variants: '變體',
        unitsOnHand: '現有庫存單位',
        minimumThreshold: '最低門檻',
        adjust: '調整',
        all: '全部',
        lowStock: '庫存不足',
        variantsDetails: '變體詳細資料',
        qty: '數量',
        addSafetyStock: '新增安全庫存',
        searchByNameSku: '按名稱/SKU 搜尋',
        safetyStockShort: '安',
        warehouseSafetyStock: '倉庫安全庫存'
    },
    low_alert_stock: '輸入安全存量數量',
    lowStockAlertNotify: '當存貨低於設定數量時，您會收到通知',
    applyButtonStockAlert: '套用',
    cancelButtonStockAlert: '取消',
    searchProductLabel: '搜尋產品...',
    successfullyAddedSafetyStock: '安全存量更新成功',
    safety_Stock: '安全存量',
    safety_stock_placeholder: '輸入安全存量',
    lowStockDetailsInfo: {
        ProductCode: '產品編號',
        SafetyStock: '安全存量',
        Stock: '存貨',
        CostPrice: '成本價',
        SellingPrice: '售價',
        Category: '類別',
        Description: '描述',
        ExpirationDate: '到期日期'
    },
    CustomLang: {
        Attribute: '屬性',
        AddAttribute: '新增屬性',
        EditAttribute: '編輯屬性',
        CustomLabePlaceholder: '輸入屬性名稱',
        CustomLabePlaceholderSelect: '揀選類型',
        AddMoreAttribute: '新增更多屬性',
        ItemAttribute: '貨品屬性',
        TableName: '名稱',
        TableType: '類型',
        TableAction: '操作',
        TableDelete: '刪除',
        TableEdit: '編輯',
        deleteMessage: '屬性刪除成功',
        editSuccessMessage: '屬性更新成功',
        AddSuccessMessage: '屬性新增成功',
        AddAtt: '新增',
        EditAtt: '編輯',
        SubmitAtt: '提交緊...'
    },
    Expenses: {
        ExpensesTitle: '開支',
        AddExpenses: '新增開支',
        ExpenseCategory: '開支類別',
        NoExpenseCategory: '暫無開支類別',
        AddExpenseCategory: '新增開支類別',
        SelectExpenseCategory: '揀選開支類別',
        NoExpenses: '暫無開支記錄',
        ExpensesSuccess: '開支新增成功',
        ExpensesSuccessEdit: '開支更新成功',
        ExpensesCategoryName: '開支類別名稱',
        ExpensesSuccessDelete: '開支刪除成功',
        AddNEC: '新增開支類別',
        NC: '新開支類別',
        EditNEC: '編輯開支類別'
    },
    Manufacturing: {
        ProducedProduct: "產出產品",
        QuantityManufactured: "製造數量",
        UnitCost: "單位成本",
        RawMaterialsTotal: "原材料總計",
        TotalManufacturingCost: "總製造成本",
        NoRawMaterialsConsumed: "未消耗原材料。",
        CostBreakdown: "成本明細",
        GeneratedBatch: "生成批次",
        StoredBinLocation: "存儲庫位",
        NoManufacturingTransactionsFound: "未找到製造交易記錄",
        AddManufacture: '新增製造詳情',
        Manufacturing: '製造',
        RawMaterials: '原材料',
        AdditonCosts: '額外成本',
        RawMaterial: '原材料',
        AdditonCost: '額外成本',
        TotalCost: '總成本',
        AddRawMaterial: '為以下產品新增原材料',
        AddAdditonCost: '為以下產品新增額外成本',
        AddMore: '新增更多',
        Add: '新增',
        Update: '更新',
        Updating: '提交緊...',
        ProductRequired: '產品係必填',
        QuantityRequired: '數量係必填',
        ChargeRequired: '費用係必填',
        EstimatedCostRequired: '預計成本係必填',
        PurchasePriceRequired: '採購價係必填',
        SelectCharge: '揀選費用類型',
        EstimatedCost: '預計成本',
        SelectProduct: '揀選產品',
        Quantity: '數量',
        ManufactureDetails: '製造詳情',
        BuyingPrice: '採購價',
        LabourCharge: '人工費',
        ElectricityCost: '電費',
        PackagingCharge: '包裝費',
        LogisticCost: '物流費',
        OtherCharges: '其他費用',
        Save: '儲存詳情',
        PurchasePrice: '採購價',
        Date: '日期',
        For: '對象',
        PurchaseRate: '採購單價',
        Scrolltoloadmore: '向下滾動載入更多...',
        Noproductsfound: '搵唔到產品',
        ManufacturingQuantity: '製造數量',
        ManufactureAddedSuccess: '製造詳情更新成功'
    },
    Warehouses: {
        transferOrder: '貨品轉移',
        AddTransferOrder: '新增貨品轉移',
        NewWarehouse: '新倉庫',
        newHead: '開始管理多個倉庫！',
        headTwo: '輕鬆跨多個倉庫追蹤同管理您嘅存貨',
        EnableWarehouse: '啟用倉庫',
        EnableWarehouse2: '啟用倉庫功能',
        OrganizationPrimary: '公司主要倉庫',
        Edit: '編輯',
        AreEnableWarehouse: '您確定要啟用倉庫功能？',
        Confirm: '確認',
        Cancel: '取消',
        WarehouseCreatedSuccessfully: '倉庫建立成功',
        MarkAsOP: '設為公司主要倉庫',
        MarkAsInAct: '設為停用',
        MarkAsAct: '設為啟用',
        MarkedAsInactive: '倉庫已設為停用',
        MarkedAsActive: '倉庫已設為啟用',
        MarkedAsOP: '倉庫已設為公司主要倉庫',
        WareDeletedSuccess: '倉庫刪除成功',
        SuccessfullyUpdatedWarehouse: '倉庫更新成功',
        SuccessfullyCreatedWarehouse: '倉庫建立成功',
        EditWarehouse: '編輯倉庫',
        AddWarehouse: '新增倉庫',
        WarehouseNameIsRequired: '倉庫名稱係必填',
        EnterWarehouseName: '輸入倉庫名稱',
        EnterEmail: '輸入電郵',
        EnterPhoneNumber: '輸入電話號碼',
        Location: '位置...',
        name: '倉庫名稱',
        email: '電郵',
        phoneNumber: '電話號碼',
        location: '位置',
        ViewProducts: '查看產品',
        PageTitle: '倉庫',
        noWarehouse: "沒有倉庫符合您的搜尋"
    },
    Assets: {
        headerTitle: '資產',
        addAssetMessage: '喺呢度新增資產。要將資產分配畀員工，請去員工個人資料頁面。',
        addAsset: '新增資產',
        editAsset: '編輯資產',
        assetCode: '資產編號',
        assetName: '資產名稱',
        assetCategory: '資產類別',
        assetType: '資產類型',
        serialNumber: '序列號',
        location: '位置',
        condition: '狀況',
        selectCondition: '揀選狀況',
        fair: '一般',
        good: '良好',
        excellent: '極佳',
        poor: '差',
        notes: '備註',
        submit: '提交',
        submitting: '提交緊',
        noCategory: '暫無類別',
        selectCategory: '揀選類別',
        addAssetCat: '新增資產類別',
        addAssetCatName: '資產類別名稱',
        edit: '編輯',
        status: '狀態',
        createdAt: '建立日期',
        viewAsset: '查看資產',
        assignAsset: '分配資產',
        conditionRet: '歸還時狀況',
        searchSelectAssets: '搜尋 / 揀選資產',
        assetAssigned: '資產分配成功',
        assetReturned: '資產歸還成功',
        selectAnAsset: '請揀選一項資產',
        action: '操作',
        noAssetAssigned: '暫無已分配資產',
        reAssigned: '重新分配',
        assignedAssetsList: '已分配資產清單',
        viewHistory: '查看記錄',
        history: '資產記錄',
        loadingHistory: '載入記錄緊...',
        loadingMore: '載入更多...',
        dateTime: '日期及時間',
        staff: '員工',
        AssignedBy: '分配者',
        assign: '分配',
        return: '歸還',
        unknown: '未知',
        noHistory: '呢項資產暫無記錄。',
        enterReturnNote: '輸入歸還備註',
        returnNote: '歸還備註',
        enterAssignNote: '輸入分配備註',
        assignNote: '分配備註',
        AddNAC: '新增資產類別',
        EditNAC: '編輯資產類別',
        others: '其他'
    },
    LedgerTransaction: {
        ledgerDetails: '分類帳詳情',
        productName: '產品名稱',
        totalQty: '總數量',
        date: '日期',
        receivedAmt: '已收金額',
        paid: '已付',
        discount: '折扣',
        balance: '結餘',
        more: '更多',
        total: '總額',
        ledgerupdatedsuccessfully: '分類帳更新成功',
        ledgeraddedsuccessfully: '分類帳新增成功',
        viewLedger: '查看分類帳',
        edit: '編輯',
        create: '建立',
        Recieved: '收到 [入貨]',
        payMode: '付款方式',
        Refno: '參考編號'
    },
    ExtraField: {
        attachment: '附件',
        acceptOnlyImg: '只接受圖片。',
        addAttribute: '新增屬性',
        acceptImgAndDoc: '接受圖片同文件。'
    },
    phoneInvoiceDownload: {
        Variant: '變體',
        Warehouse: '倉庫',
        Bin: '儲位',
        Batch: '批次',
        Attributes: '屬性'
    },
    ImportExcel: {
        ImportStockfromExcel: '從 Excel 匯入存貨',
        DragDrop: '拖放已填好嘅 Excel 檔案到呢度，或者點擊瀏覽',
        DT: '下載模板',
        GB: '返回',
        Downloading: '下載緊...',
        ChangeFile: '更換檔案',
        ReadingExcelfile: '讀取 Excel 檔案緊...',
        Processing: '處理緊...',
        submitUpdateStock: '提交並更新存貨',
        downloadLatestTemplate: '下載最新模板',
        loginRequired: '需要登入'
    },
    stockForm: {
        recordPaymentNow: "立即記錄付款",
        recordPaymentDescCustomer: "輸入客戶支付的金額",
        recordPaymentDescSupplier: "輸入供應商支付的金額",
        managePayments: "管理付款",
        invoice: "發票",
        challan: "提貨單",
        recordPayment: "記錄付款",
        payableAmount: "應付金額",
        paidAmount: "已付金額",
        paymentMethod: "付款方式",
        paymentDate: "付款日期",
        reference: "參考編號",
        billId: "單據編號",
        importExcel: "從 Excel 匯入",
        noThanks: "唔使，謝謝",
        checkHistory: "查看您的記錄",
        wantViewHistory: "您想查看記錄嗎？",
        enterPayable: '輸入應付金額',
        enterPaid: '輸入已付金額',
        selectPayment: "揀選付款方式",
        attachment: "附件",
        note: "備註"
    },
    HistoryEdit: {
        products: "產品",
        add_product: "新增產品",
        paidAmountInvalidMessage: '已付金額唔可以大過應付金額',
        removingText: "移除呢個產品會將呢次交易嘅存貨變更還原。",
        remove: "移除",
    },
    ExcelProduct: {
        uploadFile: "上載檔案",
        dragDrop: "拖放您的 Excel 檔案，或者點擊上載。",
        parsingFile: "解析檔案緊",
        fileSelected: "已揀選檔案",
        reviewImportedData: "請喺下面檢查匯入嘅資料。欄位已盡量自動對應。",
        changeFile: "更換檔案",
        back: "返回",
        invalidFileType: "請上載有效嘅 Excel 檔案（.xlsx 或 .xls）",
        parseExcelError: "Excel 解析錯誤：",
        noData: "上載嘅 Excel 檔案冇資料。",
        failedToRead: "無法讀取 Excel 檔案。請再試一次。",
        Nodata: "NO_DATA",
        unableToRead: "無法讀取檔案。",
        buyingMustNumber: "成本價必須係數字",
        sellingMustNumber: "售價必須係數字",
        mustBeNumber: "必須係數字",
        bulkUploadfailed: "批量上載失敗",
        importFromExcel: "從 Excel 匯入",
        generating: "生成緊...",
        downloadTemplate: "下載模板",
        uploading: "上載緊...",
        done: "完成",
        requiredField: "{field} 係必填",
        bulkUpload: "批量上載",
        duplicateSku: "發現重複的 SKU",
        uploadedSuccessfully: "所有產品已成功上傳！",
        uploadCompleteIssues: "上傳完成但有問題",
        uploaded_products: "已上傳 {count} 件產品。",
        failed_products: "{count} 件失敗。",
        failed_items: "失敗項目："
    },
    ProductForm: {
        barcodeQuantity: "輸入條碼數量",
        baseUnit: "基本單位（主要）",
        addSecondaryUnit: "新增副單位？",
        selectUnit: "揀選單位",
        subUnitDetails: "副單位詳情",
        subUnit: "副單位",
        selectSubUnit: "揀選副單位",
        conversionRate: "轉換率",
        exampleLogic: "例子邏輯：",
        example: "如果您賣筆係以盒為單位，就將基本單位設為「盒」，再新增副單位「支」，轉換率設為 50，即代表 1 盒 = 50 支。",
        basePrice: "基本價格",
    },
    barcode: {
        settings: '條碼設置',
        labelSize: '標籤尺寸',
        customSize: '自定義尺寸...',
        widthMm: '寬度 (mm)',
        heightMm: '高度 (mm)',
        showPrice: '在標籤上顯示售價',
        noPrices: '未為此產品配置售價。',
        preview: '預覽',
        generate: '生成',
        label: '標籤',
        singlePage: '單頁',
        downloadOptions: '下載選項',
        chooseLayout: '選擇條碼佈局',
        allInSinglePage: '將所有條碼添加到單頁中。',
        allInA4Grid: '全部在一頁中',
        allInA4GridSub: '將所有條碼排列在 A4 網格中',
        onePerPage: '每頁一個',
        onePerPageSub: '每個條碼位於其自己的標籤頁'
    },

    Discount: {
        overallDiscount: "整體折扣",
        final: '最終金額',
        balanceDue: "尚餘金額",
        tax: "稅項",
    },
    TransferItem: {
        transferItem: '貨品轉移',
        Date: '日期',
        Reason: '原因',
        enterReason: "輸入原因",
        Name: '名稱',
        QuantityTransfered: '轉移數量',
        SWarehouse: '來源倉庫',
        SelectSWarehouse: '揀選來源倉庫',
        DWarehouse: '目標倉庫',
        SelectDWarehouse: '揀選目標倉庫',
        CreatedBy: '建立者',
        CreatedTime: '建立時間',
        UpdatedTime: '更新時間',
        NoOrderFound: '搵唔到訂單',
        New: '新建',
        WarehouseItemTransfer: '倉庫貨品轉移',
        TotalTransfers: "總轉移數",
        EnterReason: '輸入原因',
        ItemDetails: '貨品詳情',
        CurrentAvailable: '現有可用量',
        TransferQty: '轉移數量',
        SStock: '來源存貨',
        DStock: '目標存貨',
        addDescription: "為貨品新增描述",
        selectVariant: "揀選變體",
        addNewRow: "新增一行",
        typeOrSelectItem: "輸入以搜尋",
        scrollToLoadMore: "向下滾動載入更多",
        noProductsFound: "搵唔到產品",
        selectWarehouse: "揀選倉庫"
    },
    Sku: {
        searchSelectProduct: "搜尋 / 揀選產品",
        searchSelectSku: "搜尋 / 揀選 SKU",
        noSkuFound: "搵唔到 SKU"
    },
    HistoryPage: {
        addFilter: "新增篩選",
        filtersActive: "所有篩選已啟用",
        noProducts: "暫無產品",
        download: "下載",
        recentlyUpdated: "最近更新",
    },
    StockPage: {
        challanNumber: "提貨單編號",
        subTotal: "小計",
        totalTaxes: "總額及稅項",
        taxInclusive: "含稅",
        discountedValue: "折扣金額",
        taxValue: "稅項金額",
        totalAmount: "總金額",
        close: "關閉",
        addTax: "新增稅項",
        label: "標籤",
        enterLabel: "輸入標籤",
        taxRate: "稅率",
        enterTaxRate: "輸入稅率",
        selectTaxRate: "揀選稅率",
        addNewTax: "新增稅率",
        discountProducts: "折扣金額（產品）",
        taxProducts: "稅項金額（產品）",
        clickAddPayment: "點擊新增付款",
        paidGreaterPayable: "已付金額唔可以大過應付金額",
        vendorCompulsory: '記錄付款必須揀選供應商',
        customerCompulsory: "記錄付款需要選擇客戶",
        updateInvoiceFormat: "更新發票格式",
        updateChallanFormat: "更新提貨單格式",
        addPrefix: "新增前綴",
        prefix: "前綴"
    },
    EditHistoryPage: {
        search_by_notes: "按備註搜尋",
        alertMessage: "呢次更改只會記錄喺歷史記錄，唔會影響現有產品存貨。",
        paymentDetails: "付款詳情",
        units: "單位",
        customLabels: "自訂標籤",
        value: "數值",
        Order_Info: "訂單資訊",
        percentage: "百分比",
        Stock_updates_on_submit: "提交时更新库存",
        Summary: "摘要"
    },
    historyCard: {
        paid: "已付清",
        partiallyPaid: "部分付款",
        billDate: "單據日期",
        productDetails: "產品詳情",
        paymentsHistory: "付款記錄",
        updatePayment: "更新付款",
        discounts: "折扣",
        inclusive: "（含）",
        discountOverall: "整體折扣金額",
        dueAmount: "尚餘金額",
        enterPaid: "輸入已付金額",
        enterReference: "輸入參考編號",
        enterNote: "輸入備註",
        enterInvoice: "輸入發票號碼",
        enterChallan: "輸入提貨單號碼",
        edit: "已編輯"
    },
    printInvoice: {
        billTo: "收款人",
        ref: "參考編號",
        mode: "付款方式",
        date: "日期",
        amount: "金額",
        totalPaid: "總已付金額",
        noImage: "冇圖片"
    },
    Contact: {
        supplier_required: "入貨必須揀選供應商",
        customer_required: "出貨必須揀選客戶",
        key: "鍵名",
        editHistory: "編輯記錄",
        loading: "載入緊..."
    },
    AW: {
        availablewarehouse: "可用倉庫",
        visibilityManagement: '可見性管理',
        availablewarehouses: "可用倉庫",
        Active: "啟用中",
        LWarehouse: "載入倉庫緊...",
        NWForthisProduct: "呢個產品暫無可用倉庫。",
        of: "之",
        WarehouseAvailabilty: "倉庫可用情況",
    },
    Currency: {
        searchCurrency: "搜尋貨幣...",
        addCurrency: "新增貨幣",
        addNewCurrency: "新增貨幣",
        editCurrency: "編輯貨幣",
        currencySymbol: "貨幣符號",
        currencyName: "貨幣名稱",
        enterCurrencySymbol: "輸入貨幣符號",
        enterCurrencyName: "輸入貨幣名稱"
    },
    NewReportLang: {
        DM: "每日移動",
        WR: "倉庫報告",
        PDM: "產品每日移動",
        TBP: "總購買價格",
        TPQ: "總產品數量",
        TP: "總產品",
        CS: "當前庫存",
        IV: "庫存價值",
        DA: "每日平均",
        TSI: "總入庫",
        TSO: "總出庫",
        TOR: "周轉率",
        Tv: "總價值",
        AST: "活躍SKU追蹤",
        UT: "追蹤單位",
        SL: "庫存水平",
        Value: "價值",
        IO: "入庫/出庫",
        T: "周轉",
        unitsD: "單位/天",
        Sort: "排序",
        Sort_by: "按以下排序",
        Units_available: "可用單位",
        Units_unavailable: "不可用單位",
        Current_assets: "流動資產",
        Search: "搜尋",
        available: "可用",
        assigned: "已指派",
        AYSWD: "確定要刪除嗎？",
        PTS: "倉庫轉移成功",
        AUS: "資產更新成功",
        ACS: "資產建立成功",
        VSP: "查看銷售價格",
        HUS: "歷史記錄更新成功",
    },
    ReplacementReturn: {
        selectProduct: "請選擇產品",
        selectReplacementProduct: "請至少選擇一個替換產品",
        validQuantity: "請輸入有效的退貨數量",
        replacedSuccessfully: "產品替換成功",
        returnSuccessfully: "產品退貨成功",
        failedProcess: "處理失敗，請再試一次。",
        return: "退貨",
        replace: "替換",
        typeSelectProduct: "輸入或選擇產品...",
        returnQuantity: "退貨數量",
        enterQuantity: "輸入數量",
        replacementDate: "替換日期",
        returnDate: "退貨日期",
        chooseCustomer: "選擇客戶",
        additionalNotes: "新增額外備註...",
        replacementProducts: "替換產品",
        addProducts: "新增更多產品",
        tapSelect: "點擊從可用產品中選擇",
        currently: "目前",
        item: "件",
        items: "件",
        selected: "已選",
        selectedItems: "已選項目",
        hideDetails: "隱藏更多詳情",
        showDetails: "顯示更多詳情",
        product: "產品",
        priceLevel: "選擇價格等級",
        customPrice: "輸入自訂價格",
        noReplaceHistory: "未找到替換記錄",
        replaceReturn: "更換及退貨",
        replaceReturnHistory: "更換及退貨記錄"
    },
    OtherComponent: {
        mfgHistoryTitle: "製造歷史",
        mfgHistoryDesc: "跟蹤製造的庫存產品",
        dailyOperation: "日常營運",
        freqUsed: "用於快速更新記錄的常用操作",
        manageCategory: "管理分類",
        organizeCaterory: "整理及管理產品、費用和資產分類",
        businessRecord: "業務記錄",
        organizeRecord: "整理及管理您的業務記錄",
        trackHistory: "追蹤歷史",
        completeTracking: "用於審計和追蹤的完整歷史記錄",
        Verifyinventorycount: "驗證庫存數量",
        Exchangerates: "匯率",
        Productiontracking: "生產追蹤",
        Fixedassetregister: "固定資產登記冊",
        Storagelocations: "儲存位置",
        warehouseAvailability: '倉庫級產品供應情況',
        Logreviewspend: "記錄及審查支出",
        Productgroupings: "產品分組",
        Classifyexpenditures: "支出分類",
        Assetclassification: "資產分類",
        Manageexchanges: "管理匯率",
        Returnauditlog: "退貨審計日誌",
        Interlocationmoves: "位置間移動",
        Manageoperationscategoriesrecordsandhistory: "管理營運、分類、記錄和歷史"
    },
    no_permission_dialog: {
        title: '無權限',
        historyDescription: "您無權限查看交易記錄。請聯絡您的管理員。",
        replacementHistoryDescription: "您無權限查看替換及退貨記錄。請聯絡您的管理員。",
        transferHistoryDescription: "您無權限查看轉倉記錄。請聯絡您的管理員。"
    },
    OthersHistory: {
        title: "管理記錄",
        transferHistory: "管理轉倉記錄",
        transactionHistory: "管理交易記錄",
        replacementHistory: "管理替換及退貨記錄"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "瀏覽並購買企業分享的產品。",
        description: "瀏覽企業分享的產品。",
        productsAvailable: "可用產品",
        noImageAvailable: "沒有圖片",
        productDetails: "產品詳情",
        inStock: "有庫存",
        availableVariants: "可用選項",
        options: "選項",
        orders: "訂單"
        ,
        searchProducts: "搜尋產品...",
        noProductsFound: "未找到產品",
        tryDifferentKeyword: "嘗試使用其他關鍵詞搜尋",
        variants: "變體",
        stock: "庫存",
        cart: "購物車",
        products: "產品",
        viewCart: "查看購物車",
        backToProducts: "返回產品",
        yourCart: "您的購物車",
        clear: "清空",
        cartEmpty: "購物車為空",
        cartEmptyDesc: "瀏覽目錄並添加您想訂購的產品。",
        browseProducts: "瀏覽產品",
        selectedItems: "已選商品",
        itemInCart: "件商品在購物車中",
        itemsInCart: "件商品在購物車中",
        customerDeliveryDetails: "客戶與配送資訊",
        fullName: "姓名",
        enterFullName: "請輸入您的姓名",
        deliveryAddress: "配送地址",
        addressPlaceholder: "街道、大廈、城市、郵編...",
        orderNote: "訂單備註（可選）",
        orderNotePlaceholder: "特殊說明或配送備註...",
        paymentMode: "付款方式",
        subtotal: "小計",
        items: "件",
        totalAmount: "總金額",
        orderOnWhatsApp: "透過WhatsApp下單 📲",
        orderPlaced: "訂單已成功提交！🎉",
        orderPlacedDesc: "您的訂單已記錄，WhatsApp已開啟。",
        continueShopping: "繼續購物 🛍️",
        cartEmptyTitle: "購物車為空",
        cartEmptyToast: "請先將產品添加到購物車。",
        incompleteTitle: "資訊不完整",
        incompleteToast: "請在下單前填寫所有必填項。",
        nameRequired: "姓名為必填項",
        addressRequired: "配送地址為必填項",
        catalogUnavailable: "目錄暫不可用",
        catalogUnavailableDesc: "此目錄當前未啟用，請聯繫商家。",
        invalidCatalogLink: "無效的目錄連結 🚫",
        invalidCatalogDesc: "此目錄頁面缺少必要資訊。",
        missing: "缺失",
        catalogSlug: "目錄標識",
        goBackHome: "返回首頁",
        inventoryManagement: "庫存管理與開票 🚀 Simply",
        enter: "輸入",
        select: "選擇",
        // Catalog Order translations
        catalogOrders: '目錄訂單',
        pending: '待處理',
        converted: '已轉換',
        cancelled: '已取消',
        totalRevenue: '總價值',
        totalCatalogOrders: '網上訂單總數',
        convertToSalesOrder: '轉換為銷售訂單',
        date: '日期',
        status: '狀態',
        action: '操作',
        searchOrders: '搜尋客戶或電話...',
        noMatchingOrders: '找不到相符訂單',
        noStatusOrders: '找不到{status}訂單',
        tryDifferentSearch: '嘗試使用不同的客戶名稱或電話號碼進行搜尋。',
        noOrdersWithStatus: '目前沒有{status}狀態的訂單。',
        noOrdersYet: '暫無目錄訂單',
        noOrdersDescription: '來自您網上目錄的訂單將顯示在這裡。',
        guestCustomer: '訪客客戶',
        item: '商品',
        moreItems: '+{count}個更多',
        viewDetails: '查看詳情',
        viewSalesOrder: '查看銷售訂單',
        cancelOrder: '取消訂單',
        confirmCancelTitle: '取消目錄訂單？',
        confirmCancelOrder: '您確定要取消此訂單嗎？此操作無法撤銷。',
        keepOrder: '否，保留訂單',
        confirmCancelAction: '是，取消訂單',
        orderNotFound: '找不到目錄訂單',
        orderNotFoundDescription: '找不到此訂單，或者您可能沒有查看權限。',
        backToCatalogOrders: '返回目錄訂單',
        placedOn: '下單時間',
        totalItems: '商品總數',
        orderedProducts: '已訂購產品',
        itemDetails: '商品詳情',
        quantity: '數量',
        unitPrice: '單價',
        total: '總計',
        variant: '款式',
        customerInformation: '客戶資訊',
        additionalFields: '附加欄位',
        fields: '欄位',
    },
    stockNew: {
        Npay: "尚未添加任何產品",
        emptydesc: "從您的目錄中選擇一個產品，並輸入進貨數量以記錄庫存。",
        tipText: "提示：您也可以上傳 excel 檔案",
        OT: "訂單總額",
        Collapse: "摺疊"
    },
    deleteBulk: {
        Bulkoperation: "批量操作",
        Applyproducts: "對多個產品應用操作",
        Bulkupload: "批量上載",
        ImportCSVfile: "透過 Excel 或 CSV 檔案匯入產品",
        or: "或",
        Bulkdelete: "批量刪除",
        Permanentlyallproducts: "永久移除所有產品",
        IrrText: "批量刪除無法復原。如有需要，請先匯出備份。",
        SeP: "已選產品",
        sP: "選擇產品",
        DA: "全部刪除",
        DP: "刪除產品",
        sL: "全選",
        ASDE: "確定要刪除除",
        ASDAllP: "確定要刪除所有產品嗎？",
        ASD: "確定要刪除",
        products: "個產品",
        TACBU: "此操作無法撤銷。",
        LP: "正在載入產品...",
        FM: "正在載入更多...",
        NPF: "未找到產品。",
        LMP: "正在載入更多產品..."
    },
    NewVariantModal: {
        Definevariantsassign: "定義變體並分配數量",
        Nothingallocated: "未分配任何數量",
        Overallocated: "超額分配",
        Fullyallocated: "已完全分配",
        Overby: "超額",
        Allvariantsneedaname: "所有變體都需要名稱。",
        Reducequantities: "減少數量。",
        Overallocatedby: "超額分配",
        Quantitiesmustmatchthetotalavailability: "數量必須與總可用量匹配。",
        Allocatequantitiesacrosswarehouses: "跨倉庫分配數量",
        Notfullydistributed: "未完全分配：",
        remaining: "剩餘",
        Qty: "數量",
        Inactive: "未啟用",
        left: "剩餘"
    },
    ProductFormNew: {
        BasicInfo: "基本資料",
        ProductImage: "產品圖片",
        Images: "圖片",
        Pricing: "定價",
        Everypriceneedsbothalabelandanamount: "每個價格都需要標籤及金額",
        AddalabellikeWholesaleorRetailtoidentifythisprice: '加入類似「批發」或「零售」的標籤以識別此價格',
        AddMultiplePrice: "新增多個價格",
        NoPhotosLetAiFind: "沒有照片？讓 AI 尋找產品圖片",
        AddProductImagesTitle: "新增產品圖片",
        ChooseHowToAddPhotos: "選擇為此產品新增照片的方式：",
        SearchWithAi: "使用 AI 搜尋",
        SearchWithAiDesc: "使用 AI 自動尋找並選擇產品圖片",
        FilesFileExplorer: "檔案（檔案總管）",
        FilesFileExplorerDesc: "直接從您的電腦中選擇圖片",
        AiProductImageFinder: "AI 產品圖片尋找器",
        AiProductImageFinderDesc: "為您的產品搜尋並選擇圖片",
        TypeProductNamePlaceholder: "輸入產品名稱...",
        SearchForYourProduct: "搜尋您的產品",
        SearchForYourProductHint: `嘗試品牌或產品名稱，例如 "Kirkland 米諾地爾"`,
        ImagesSelected: "張圖片已選擇",
        AddSelected: "新增所選"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "定義新的自訂欄位",
        AttributeName: "屬性名稱",
        DataType: "資料類型",
        Noattributesfound: "找不到屬性",
        ManageAttributes: "管理屬性",
        Editordeleteexistingattributes: "編輯或刪除現有屬性",
        UpdateAttribute: "更新屬性",
        Saving: "儲存中..."
    },
    NewExpenses: {
        Noexpensesyet: "暫無支出",
        Addyourfirstexpensetostarttrackingyourspending: "新增您的第一筆支出，以開始追蹤您的消費。",
        TOTALEXPENSES: "總支出",
        ENTRIES: "項目",
        BYCATEGORY: "按類別",
        Nocategoriestodisplay: "沒有可顯示的類別",
        DateanfTime: "日期及時間"
    },
    PurchaseSales: {
        CancelOrder: "取消訂單",
        ReopenOrder: "重新開啟訂單",
        Reopen: "重新開啟",
        ConfirmCancelOrder: "您確定要取消此訂單嗎？",
        ConfirmReopenOrder: "您確定要重新開啟此訂單嗎？",
        OrderCancelledSuccessfully: "訂單已成功取消。",
        OrderReopenedSuccessfully: "訂單已成功重新開啟。",
        CancelledBy: "取消者",
        Cancelled: "已取消",
        ConvertPriceBasedOnUnitConversion: "根據單位換算轉換價格",
        MarkPaymentAsPending: "將付款標記為待處理",
        PendingReceivableDesc: "金額已記錄為應收款。收到款項時記錄付款。",
        PendingPayableDesc: "金額已記錄為應付款。付款時記錄付款。",
        SelectCustomerFirst: "請先選擇客戶",
        SelectSupplierFirst: "請先選擇供應商",
        SelectItemsFirst: "請先選擇至少一項商品",
        PaymentMarkedPendingDesc: "付款已標記為待處理。取消勾選「將付款標記為待處理」以立即記錄付款。",
        SelectCustomerAndItemFirst: "請先選擇客戶和至少一個項目",
        SelectSupplierAndItemFirst: "請先選擇供應商和至少一個項目",
        SelectCustomerProductFirst: "請先選擇客戶和產品",
        SelectSupplierProductFirst: "請先選擇供應商和產品",
        Receivables: "應收賬款",
        Payables: "應付賬款",
        AccessDenied: "存取被拒",
        YouDonthaeP: "您沒有權限查看此頁面。如認為這是錯誤，請聯絡您的管理員。",
        purchase: "採購",
        sales: "銷售",
        Areyousureyouwantto: "您確定要",
        Thisactionwillupdateitsstatus: "此動作將更新其狀態。",
        ReasonOPtional: "原因（可選）",
        Enterareasonfor: "請輸入原因",
        optionalDot: "(可選)...",
        Reject: "拒絕",
        ConfirmOrder: "確認訂單",
        RejectOrder: "拒絕訂單",
        Previous: "上一個",
        First: "第一個",
        Order: "訂單",
        Items: "貨品",
        Memo: "備註",
        SelectDateRange: "選擇日期範圍",
        List: "列表",
        Board: "看板",
        View: "檢視",
        CreateSalesOrder: "建立銷售訂單",
        CreatePurchaseOrder: "建立採購訂單",
        successfully: "成功",
        ManageAttachments: "管理附件",
        Stockoutitemsimmediatelyaftersaving: "儲存後立即出庫貨品。",
        Stockinitemsimmediatelyaftersavingthisorder: "儲存此訂單後立即入庫貨品。",
        ViewAttachments: "檢視附件",
        MemoAttachments: "備註與附件",
        ReceivedDate: "接收日期",
        ShippedDate: "出貨日期",
        OrderDate: "訂單日期",
        OrderDetails: "訂單詳情",
        Subtotal: "小計",
        OrderSummary: "訂單摘要",
        AddItem: "新增貨品",
        NewSalesOrder: "新銷售訂單",
        NewPurchaseOrder: "新採購訂單",
        Createandmanageyour: "建立及管理您的",
        orders: "訂單",
        Removeitem: "移除貨品",
        UnitPrice: "單價",
        PurchaseOrder: "採購訂單",
        SalesOrder: "銷售訂單",
        PurchaseInvoice: "採購發票",
        SalesInvoice: "銷售發票",
        PurchaseOrdernotfound: "找不到採購訂單",
        Approve: "批准",
        MarkasShipped: "標記為已出貨",
        MarkasReceived: "標記為已接收",
        Marking: "標記中...",
        PartiallyShip: "部分出貨",
        PartiallyReceive: "部分接收",
        Deleting: "刪除中...",
        Transaction: "交易",
        Details: "詳情",
        Item: "貨品",
        Received: "已接收",
        Shipped: "已出貨",
        Ordered: "已訂購",
        units: "單位",
        Overalldiscount: "總折扣",
        Transactions: "交易記錄",
        Notransactionsfound: "找不到交易",
        OrderedQty: "訂購數量",
        Totalqty: "總數量",
        StockingOut: "出庫中...",
        StockingIn: "入庫中...",
        thiorderUpdateStuau: "此訂單？此動作將更新其狀態。",
        TransactionDetails: "交易詳情",
        Fetchingtransactiondetails: "正在取得交易詳情...",
        Nodetailsfoundforthistransaction: "找不到此交易的詳情。",
        TotalBreakDown: "總額明細",
        ChangeAmount: "找零金額",
        Attachments: "附件",
        PoNumber: "採購單號",
        SoNumber: "銷售單號",
        partner: "合作夥伴",
        EditPurchase: "編輯採購",
        EditSales: "編輯銷售",
        PurchaseOrderDetails: "採購訂單詳情",
        SalesOrderDetails: "銷售訂單詳情",
        OrderType: "訂單類型",
        SelectOrderType: "選擇訂單類型",
        OrderTypePrepaid: "預付款",
        OrderTypeCOD: "貨到付款",
        OrderTypePayLater: "稍後付款",
        OrderTypePartialPayment: "部分付款",
        OrderTypeSubscription: "訂閱",
        viewAvailabilty: '查看可用時間',
        NotReceived: "未收貨",
        NotShipped: "未發貨",
        PartiallyReceived: "部分收貨",
        PartiallyShipped: "部分發貨",
    },
    PriceReference: {
        HighPrice: "最高價",
        LowPrice: "最低價",
        LastPrice: "最新價",
        LastPurchasePrice: "最新採購價格",
        Nopricerecordsfound: "未找到價格記錄",
        BuyingPriceReference: "採購價參考",
        SellingPriceReference: "銷售價參考",
        Viewstockinpricesfortheselectedvendorandproduct: "查看所選供應商及產品的入庫價格",
        Viewstockoutpricesfortheselectedcustomerandproduct: "查看所選客戶及產品的出庫價格"
    },
    SubscriptionLocale: {
        premiumPlan: "高級方案",
        heading: "作出商業決策",
        headingHighlight: "基於數據",
        subtitle: "解鎖您商業分析的全部力量 — 無限制，無妥協。",
        choosePlan: "選擇您的方案",
        monthly: "按月",
        annual: "按年",
        oneTime: "一次性 (月租)",
        perMonth: "每月",
        perYear: "每年",
        bestValue: "最佳價值",
        continueWith: "繼續使用",
        perMonthShort: "月",
        perYearShort: "年",
        troubleWithSubscription: "訂閱遇到問題？",
        contactUs: "聯絡我們",
        paymentNotReady: "付款未就緒",
        checkoutError: "結帳錯誤",
        pricePreviewError: "價格預覽錯誤",
        subNotAvailable: "訂閱不可用",
        subNotAvailableDesc: "目前您所在的國家/地區無法使用網頁訂閱。請透過我們的手機應用程式訂閱或聯絡我們以獲取協助。"
    },
    SubscriptionLocale2: {
        GoPro: "升級至 Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "基於真實業務數據做出更明智的決策",
        ExploreProPlans: "探索 Pro 方案"
    },
    emptyWarehouseState: {
        tips: [
            "您可以為不同實體位置設置多個倉庫",
            "每個產品按倉庫獨立追蹤庫存",
            '使用「倉庫調撥」在不同位置之間移動庫存'
        ],
        NoWarehousesConfigured: "未配置任何倉庫",
        desc: "首先新增您的倉庫（如果有多於一個），然後新增產品並記錄庫存變動。",
        WarehouseSetupTips: "倉庫設置提示",
        Noproductselected: "未選擇任何產品",
        Selectaproductfromthelefttoviewlowstockdetails: "從左側選擇產品以查看低庫存詳情。",
        Chooseaproductfromthelist: "從清單中選擇產品",
        SelectProduct: "選擇產品",
        SetQuantity: "設定數量",
        Showing: "顯示",
        products: "產品",
        Continue: "繼續",
        SaveSafetyStock: "儲存安全庫存",
        SafetyStockSaved: "安全庫存已儲存！",
        hasbeensetto: "已設定為",
        AddAnother: "新增另一個",
        Chooseaproduct: "選擇產品",
        Step: "步驟",
        of: "的",
        Setsafetyquantity: "設定安全數量",
        Complete: "完成",
        SafetyStockQuantity: "安全庫存數量",
        Minimumunitsdropsbelowthisnumber: "始終要在庫存中保持的最低單位數。當庫存低於此數字時會觸發警報。",
        NewSafetyStock: "新的安全庫存",
        SafetyNow: "目前安全庫存",
        SettingTo: "正在設定為",
        Change: "更改",
        sell: "銷售",
        cost: "成本",
        BulUD: "批量上載/刪除"
    },
    SimplyLoginUI: {
        sslEncryption: "256位 SSL 加密",
        dataPrivate: "您的資料 100% 私密",
        worksOnDevices: "支援 Android 及 iPhone",
        realTimeSync: "所有裝置即時同步",
        cloudBackup: "自動雲端備份",
        availableOn: "支援網頁、Android 及 iOS",
        tagline: "您的庫存，",
        taglineEm: "簡潔優雅。",
        subtitle: "登入即可管理庫存、追蹤銷售，讓您的業務順暢運作 —— 一切盡在一處。",
        feature1Title: "即時庫存追蹤",
        feature1Desc: "準確掌握每個倉庫的庫存情況，時刻保持最新。",
        feature2Title: "銷售與採購訂單",
        feature2Desc: "建立發票、管理供應商，並追蹤每一筆交易。",
        feature3Title: "智能報告",
        feature3Desc: "財務、庫存及每日動態報告一目了然。",
        feature4Title: "所有裝置即時同步",
        feature4Desc: "手機上的更改會即時顯示在網頁上 —— 反之亦然。",
        rating1: "評分",
        rating2: "4.9/5",
        rating3: "來自 10,000 家批發企業",
        brandName: "Simply",
        greeting: "歡迎回來！👋",
        noPasswordNeeded: "登入即可存取您的庫存 —— Android、iPhone 及網頁，完全同步。",
        badge1: "庫存管理",
        badge2: "銷售追蹤",
        badge3: "報告",
        trustEncryptedTitle: "已加密",
        trustEncryptedSub: "256位 SSL",
        trustPrivateTitle: "私密",
        trustPrivateSub: "僅您的資料",
        trustBackedTitle: "已備份",
        trustBackedSub: "每日自動",
        availableOnLabel: "支援平台",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "網頁",
        syncBadge: "所有裝置即時同步",
        securityNote: "100% 安全。",
        securityDesc: "銀行級加密保護您的所有資料。我們只會讀取您的姓名和電郵 —— 其他一無所知，永遠如此。",
        signingIn: "正在登入…",
        termsPrefix: "登入即表示您同意 Simply 的",
        privacyPolicy: "私隱政策",
        and: "及",
        termsOfService: "服務條款",
        google: "使用 Google 登入"
    },
    BatchLocal: {
        BatchName: "批次名稱",
        EnterBatchName: "輸入批次名稱",
        EnterNotes: "輸入備註",
        ExpiredDate: "到期日期",
        Selectexpireddate: "選擇到期日期",
        BatchStatus: "批次狀態",
        CreatedDate: "建立日期",
        Areyousureyouwanttodeletethisbatch: "您確定要刪除此批次嗎？",
        Youhavencreatedanybatchforthisproduct: "您尚未為此產品建立任何批次。",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "建立您的第一個批次，開始按批次和到期日期追蹤庫存。",
        Nobatchesyet: "暫無批次",
        Whatisbatchmanagement: "什麼是批次管理？",
        Howithelpsyourbusiness: "它如何幫助您的業務",
        Trackbylotnumber: "按批號追蹤",
        Trackbylotnumberdesc: "按製造商批次對庫存進行分組，以便您始終知道每個單位來自哪個批次。",
        Expirydatecontrol: "到期日期控制",
        Expirydatecontroldesc: "在庫存到期前收到警報。先銷售較舊的批次，自動減少浪費。",
        Fulltraceability: "完全可追溯性",
        Fulltraceabilitydesc: "查看每筆交易中使用了哪個批次 — 非常適合審計和召回。",
        Supplierwisestock: "按供應商劃分庫存",
        Supplierwisestockdesc: "即使是同一產品，也要將不同供應商的庫存分開。按批次比較質量。",
        Createyourfirstbatchbutton: "建立您的第一個批次",
        Nomatchesfound: "未找到匹配項",
        NomatchesfounddescBefore: "我們找不到與 ",
        NomatchesfounddescAfter: " 匹配的任何批次。",
        Clearsearch: "清除搜尋",
        Nohistoryfoundthisbatch: "此批次沒有找到歷史記錄",
        ComprehensiveDetails: "詳細資訊",
        History: "歷史記錄",
        InBatch: "在批次中",
        Noproductfoundinthisbatch: "此批次中未找到產品",
        SelectBatch: "選擇批次",
        available: "可用",
        Searchbatches: "搜尋批次...",
        Expires: "到期",
        Nobatchesfound: "未找到批次",
        ManageBatches: "管理批次",
        Batchmanagement: "批次管理",
        Trackstockexpiry: "按批次和到期日期追蹤庫存",
        Turnoffbatchmanagement: "關閉批次管理？",
        Yourgsafe: "您現有的批次資料將保持安全。",
        Reenableanytimefrom: "您可以隨時從",
        Otherstab: "其他選項卡",
        AddBatch: "新增批次",
        Total: "總計",
        AssignProduct: "分配產品",
        EditProductAssignment: "編輯產品分配",
        AssignProducttoBatch: "將產品分配到批次",
        Updateproductconfiguration: "更新產品配置",
        Step1of2: "第 1 步，共 2 步",
        Step2of2: "第 2 步，共 2 步",
        Selectvariantwarehouse: "選擇變體和倉庫",
        SelectedProduct: "已選產品",
        AssignQuantity: "分配數量",
        BatchInfo: "批次資訊",
        Wecouldnthisproductidentifier: "我們找不到與此產品識別碼關聯的任何批次。",
        NoActiveBatches: "沒有活動批次",
        Endofresults: "結果結束",
        Expiry: "到期",
        BatchManagementDescription: "透過批號與到期日期追蹤庫存。確保每次出庫時自動採用正確的 LIFO / FEFO 順序 — 無需手動揀貨。",
        Expiryalerts: "到期提醒",
        Autonotifications: "自動通知",
        LIFOsorting: "LIFO / FEFO 排序",
        Smartstockflow: "智能庫存流動",
        Perout: "逐批出庫",
        Precisiontracking: "精準追蹤",
        NeedsReview: "需要審核",
        Pending: "待處理",
        Rejected: "已拒絕",
        Approved: "已批准",
        WaitingForApproval: "等待批准",
        WaitingForApprovalDesc: "您的擁有者將很快審核並批准此批次。",
        BatchRejected: "批次被拒絕",
        BatchRejectedDesc: "您的擁有者拒絕了此批次。",
        Reason: "原因",
        Approve: "批准",
        Reject: "拒絕",
        ConfirmApproveTitle: "批准批次",
        ConfirmRejectTitle: "拒絕批次",
        ConfirmApprovalAction: "您確定要{action}此批次嗎？此操作將更新其狀態。",
        ReasonOptional: "原因（可選）",
        EnterReasonPlaceholder: "輸入{action}的原因（可選）",
        Processing: "處理中...",
        BatchActivatedSuccess: "批次已成功啟用",
        BatchDeactivatedSuccess: "批次已成功停用",
        BatchDeletedSuccess: "批次已成功刪除",
        BatchApprovedSuccess: "批次已成功批准",
        BatchRejectedSuccess: "批次已成功拒絕",
        SearchByBatchName: "按批次名稱搜尋...",
        YesTurnOff: "是，關閉",
        KeepItOn: "保持開啟"
    },
    CategoryNewL: {
        TotalCategories: "總類別數",
        lastaddedcategory: "上次新增的類別",
        acrossalltypes: "跨所有類型",
        MostRecent: "最近",
        YesD: "是的，刪除",
        AllAssociated: "所有相關產品都可能受到影響"
    },
    OverDas: {
        movestockbetweenlocations: "移動庫存",
        no_activity_yet: "暫無任何活動",
        no_activity_sub: "銷售、採購、庫存移動和退貨將在此即時顯示。",
        make_first_sale: "進行第一次銷售",
        add_stock: "新增庫存",
        all_stock_healthy: "所有庫存水平正常",
        all_stock_healthy_sub: "沒有任何商品即將缺貨。請在商品上設定最低門檻，以便在此接收提醒。",
        set_stock_thresholds: "設定庫存門檻",
        no_warehouses_setup: "尚未設定任何倉庫",
        no_warehouses_setup_sub: "新增一個倉庫以開始追蹤您的庫存存放位置並管理地點。",
        add_first_warehouse: "新增第一個倉庫",
        Customer: "客戶",
        PurchasevsSales: "採購 vs 銷售",
        Financialperformancechart: "財務表現圖表",
        QuickActions: "快速操作",
        Frequentlyused: "常用功能",
        Addinventory: "新增庫存",
        Dispatchitems: "調撥商品",
        Addorder: "新增訂單",
        Newitem: "新商品",
        Inventoryaccess: "庫存存取",
        Itemsneedingreorder: "需要補貨的商品",
        Latesttransactions: "最新交易",
        Operationalsummary: "營運摘要",
        ViewAll: "查看全部",
        Manage: "管理",
        RecentActivity: "最近活動",
        LowStockAlerts: "低庫存提醒",
        Primary: "主要",
        TotalWarehouses: "倉庫總數"
    },
    SerialLocal: {
        ShowOrHideFields: "顯示或隱藏欄位",
        ShowOrHideFieldsDesc: "點擊下方的任何項目以將其包含在列印的發票中或從中移除。更改會立即生效。",
        Manufacturesettings: "製造設定",
        Showbuyingprice: "購買價 / 產品成本",
        Showadditionalcost: "額外費用",
        Costbreakdown: "費用明细",
        Unitcost: "單位成本",
        Rawmaterialstotal: "原材料總計",
        Confirmentry: "確認輸入",
        SaveSerials: "儲存序號",
        SerialNumber: "序號",
        selected: "已選擇",
        added: "已新增",
        Serialnumbers: "序號",
        ResetAll: "全部重設",
        Wecouldnfindthis: "找不到此產品的可用序號。",
        Nounitsfound: "找不到任何單位",
        Searchingserialnumbers: "正在搜尋序號...",
        Scanorenterstock: "掃描或輸入新庫存的序號",
        Whataserialnumber: "什麼是序號？",
        Auniqueidentifieryourinventorylifecycle: "每個單位獨一無二的識別碼 — 可讓您在整個庫存生命週期中追蹤每個個別項目。",
        Trackedstockout: "已追蹤出庫",
        Chooseexactlyselected: "請準確選擇要離開的序列號。只會顯示此產品已入庫的序列號 — 選擇後數量將被鎖定 ",
        SelectSerialstoout: " - 選擇要出庫的序號",
        Thisinvoicegeneratedusingwwwsimplstockco: "此發票使用 www.simplstock.co 生成",
        AuthorizedSignature: "授權簽名",
        Invoicesettings: "發票設定",
        Draw: "繪製",
        Taptoselectordeselectitems: "點擊以選擇或取消選擇項目",
        Thissignaturewillbeadded: "此簽名將新增至您列印發票的底部。",
        SignatureOptions: "簽名選項",
        Upload: "上傳",
        DrawSignature: "手繪簽名",
        UploadSignature: "上傳簽名",
        Clear: "清除",
        ShowStaffName: "員工姓名",
        ShowSKU: "SKU",
        ShowBusinessName: "公司名稱",
        ShowProductName: "產品名稱",
        ShowBusinessPhoneNumber: "業務電話號碼",
        ShowBusinessEmail: "業務電子郵件",
        ShowBusinessAddress: "業務地址",
        ShowProductImage: "產品圖片",
        ShowPaymentDetails: "付款詳情",
        ShowCategory: "分類",
        ShowVariant: "規格",
        ShowWarehouse: "倉庫",
        ShowAttributes: "屬性",
        ShowQuantity: "數量",
        ShowDiscount: "折扣",
        ShowTax: "稅金",
        ShowPrice: "價格",
        ShowTotalPrice: "產品總價",
        ShowExpenses: "費用",
        ShowSignature: "簽名",
        ShowNote: "備註",
        showAttachment: "附件",
        ShowSerialNumber: "序號",
        Invoicesettingsapplied: "發票設定已套用。请檢查發票以查看變更。",
        EnterSerialNumber: "輸入序號",
    },
    FewLocal: {
        SelectBin: "選擇貨位",
        Live: "即時",
        Monitorinventorystocklevels: "監控庫存、移動及庫存水平",
        StockControlCentre: "庫存控制中心",
        Nochartdataavailable: "沒有圖表數據",
        Disabled: "已停用",
        Enabled: "已啟用"
    },
    Bin: {
        Bin: "貨位",
        Add: "新增",
        NoBinsAddedYet: "尚未新增任何貨位",
        BinLocationsHelp: "貨位有助您按照倉庫內的精確位置追蹤庫存 — 無需再搜尋。",
        NameThemByPosition: "按位置命名：",
        AddBinLocation: "新增貨位",
        BinLocations: "貨位",
        BinNameRequired: "貨位名稱必填",
        EditBin: "編輯貨位",
        AddBin: "新增貨位",
        EnterBinName: "貨位名稱",
        EnterBinNamePlaceholder: "輸入貨位名稱",
        BinStatus: "貨位狀態",
        BinNotes: "備註",
        EnterBinNotesPlaceholder: "新增一些備註...",
        ViewInventory: "查看庫存",
        Inventory: "庫存",
        TrymatchingadifferentSKUname: "嘗試匹配其他SKU或名稱。",
        Thisbinlocationcurrentlyempty: "此貨位目前為空。",
        Loadingbins: "正在載入貨位...",
        bins: "貨位",
        ManageBin: "管理貨位",
        Print: "列印",
        SBin: "源儲位",
        DBin: "目的地儲位"
    },
    WarehouseExcel: {
        title: "上傳倉庫 & 貨位",
        description: "按照以下步驟使用 Excel 檔案批量建立倉庫及其貨位。",
        bulkUploadGuide: "批量上傳指南",
        step1: "步驟 1",
        downloadTemplate: "下載 Excel 範本",
        downloadTemplateDesc: "下載已預置所有必要欄位標題的官方範本。請勿重新命名或刪除任何欄位。",
        downloadTemplateBtn: "下載範本",
        step2: "步驟 2",
        fillExcelFile: "填寫 Excel 檔案",
        fillExcelDesc: "每一列代表一個倉庫。請填寫所有欄位 — 貨位請在 <code>Bin Names</code> 欄位中用逗號分隔輸入所有貨位名稱。",
        step3: "步驟 3",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "上傳前，請確保您的檔案符合以下規則。",
        step4: "步驟 4",
        uploadYourFile: "上傳您的檔案",
        uploadDesc: "填寫完成後，上傳下方檔案。系統將自動建立所有倉庫和貨位。",
        rules: ["每個倉庫僅一列", "貨位名稱用逗號分隔在一個儲存格內", "請勿修改欄位標題名稱", "同一倉庫內重複的貨位名稱將被跳過", "帶國家代碼的電話號碼", "僅支援 .xlsx 或 .xls 檔案"],
        dropFileHere: "將 Excel 檔案拖放到此處",
        supports: "支援 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "選擇檔案並上傳",
        parsing: "正在解析檔案...",
        invalidFileType: "無效的檔案類型。請上傳 Excel 檔案。",
        noData: "Excel 中未找到資料",
        failedToRead: "無法讀取 Excel 檔案",
        unableToRead: "無法讀取檔案。",
        reviewTitle: "審核倉庫資料",
        reviewSubtitle: "匯入您的業務前的最終檢查。",
        changeFile: "更改檔案",
        rowsFound: "列已找到",
        cancel: "取消",
        finalizeImport: "完成並匯入",
        importing: "正在匯入...",
        success: "成功",
        allWarehouseUploadedSuccess: "所有倉庫已成功上傳",
        failed: "失敗",
        bulkUploadFailed: "批量上傳失敗",
        error: "錯誤",
        binNamesNote: "在 <strong>Bin Names</strong> 欄位中，將一個倉庫的所有貨位名稱用逗號分隔輸入到一個儲存格中 — 例如：A1, A2, B1, RACK-01。",
        headers: { warehouseName: "倉庫名稱", email: "電郵", phoneNumber: "電話號碼", location: "位置", binNames: "貨位名稱" }
    },
    VariantTemplate: {
        VariantTemplates: "變體模板",
        Managereusablevariantpatterns: "管理可重複使用的變體模式",
        BinTransferHistory: "貨位轉移記錄",
        Trackmovementsacrossbins: "追蹤貨位之間的移動",
        SerialNumberHistory: "序號記錄",
        Trackproductserialnumberactivity: "追蹤產品序號活動",
        Period: "期間",
        Nohistoryfound: "未找到記錄",
        Searchserialnumbers: "搜尋序號...",
        SerialNumbersHistory: "序號歷史",
        Serialnumberhistoryglance: "序號歷史一覽。",
        Noserialnumbersfound: "未找到序號",
        Noactivityhistoryfound: "未找到活動記錄",
        Statussetto: "狀態設定為",
        Timeline: "時間軸",
        Managereusableproductvariantpatterns: "管理可重複使用的產品變體模式。",
        DeleteTemplate: "刪除模板",
        Areyousureyouwanttemplate: "確定要刪除此模板嗎？",
        CreateNewTemplate: "建立新模板",
        CreateTemplate: "建立模板",
        EditTemplate: "編輯模板",
        UnlimitedTemplates: "無限模板",
        CreateAsManyTemplates: "根據需要建立任意數量的模板 — 服裝、鞋類、電子產品等。",
        PickWhileAddingProduct: "新增產品時選擇",
        OpenTemplateLibrary: "開啟模板庫，幾秒內選擇變體名稱。",
        MixFromMultipleTemplates: "從多個模板混合",
        SelectFromMultipleTemplates: "為單一產品從多個模板選擇變体名稱 — 完全靈活。",
        EditAnytime: "隨時編輯",
        RenameTemplatesAnytime: "隨時重新命名模板、新增或移除變體名稱。",
        StayConsistent: "保持一致性",
        SameVariantNamesAcrossAll: "所有產品使用相同的變體名稱。無錯字、無重複、無猜測。",
        BuildOnceUseEverywhere: "一次建立， 處處使用",
        StopReEnteringVariantNames: "停止為每個產品重複輸入相同的變體名稱。建立一次模板即可即時重用。",
        Updateexistingvariantcombinations: "更新現有變體組合",
        Definenewvariantcombinations: "定義新的變體組合",
        TemplateName: "模板名稱",
        AddVariantOptions: "新增變體選項",
        SmallMedium: "例如：小、中...",
        VariantsList: "變體列表",
        Nooptionsaddedyet: "尚未新增任何選項",
        SaveTemplate: "儲存模板",
        egSizesColorsetc: "例如：T恤尺寸、顏色等",
        Pleaseentertemplatename: "請輸入模板名稱",
        Pleaseaddatleastonevariantoption: "請至少新增一個變體選項",
        Templateupdatedsuccessfully: "模板更新成功",
        Templatecreatedsuccessfully: "模板建立成功",
        Failedtosavetemplate: "儲存模板失敗",
        Transfer: "轉移",
        Editassignment: "編輯指派",
        Updateproductdetailsinbin: "更新貨位中的產品資料",
        Editinginbin: "正在貨位中編輯",
        ConfirmUpdate: "確認更新",
        ConfirmAssign: "確認指派",
        Assignanotherproduct: "指派其他產品",
        TransferBin: "轉移貨位",
        SourceBin: "來源貨位",
        DestinationBin: "目標貨位",
        SelectSourceBin: "選擇來源貨位",
        SelectDestinationBin: "選擇目標貨位",
        Unit: "單位",
        ManageVariant: "管理變體",
        CreateSKUvariationsyourproduct: "為您的產品建立SKU變體",
        Assigningvariationsto: "正在指派變體至",
        Novariantsaddedyet: "尚未新增任何變體",
        AddedVariants: "已新增變體",
        AddVariantsfromTemplate: "從模板新增變體",
        Pickatemplateandselectvariantnames: "選擇模板並選取變體名稱",
        ChooseaTemplate: "選擇模板",
        Selectvariantnamestoadd: "選擇要新增的變體名稱",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "選擇一個模板來挑選變體名稱。您可以從多個模板新增。",
        Loadingtemplates: "正在載入模板...",
        Backtotemplates: "返回模板列表",
        Selectallindividualadd: "全选或個別選擇變體名稱新增。",
        VariantNames: "變體名稱",
        MediaDescription: "媒體 & 描述",
        Addattachmentsandproductnotes: "新增附件和產品備註",
        ProductMedia: "產品媒體"
    },
    AddProductGuide: {
        title: "儲存後新增初始數量",
        description: "產品在此沒有數量欄位。儲存後，請使用「入庫」記錄您的期初庫存 — 對位置和追蹤擁有完全控制權。",
        steps: {
            quantity: { title: "數量", sub: "設定期初庫存數量" },
            binLocation: { title: "貨位", sub: "通道、貨架、層架 — 例如：A-01-03" },
            serialNumbers: { title: "序號", sub: "個別追蹤每個單位" },
            warehouse: { title: "倉庫", sub: "儲存在哪個位置" },
            batchExpiry: { title: "批次 / 到期日", sub: "按批次號分組庫存" }
        },
        actions: { close: "關閉" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "未找到調撥單",
        Itemshistory: "您在倉庫之間轉移的物品將在此顯示，用於追蹤和歷史記錄。",
        CreateTransfer: "建立調撥"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "點擊產品進行製造",
        Selectproductfrombelow: "從下方清單中選擇產品",
        SetupANewProduct: "設置新產品",
        DefineAProductAdditsrawmaterial: "定義產品並添加其原材料",
        ManufacturingSetup: "製造設置",
        Pickproducttodefineitsproductiondetails: "選擇產品以定義其生產詳情",
        ConfigureManufacturing: "配置製造",
        SelectRawMaterial: "選擇原材料",
        NoRawMaterials: "無原材料",
        Definecomponentsneededtoproduct: "定義製造此產品所需的組件。",
        NoAdditionalCosts: "無額外成本",
        Addlaboroverheadlogisticalcharges: "添加人工、間接費用或物流費用。",
        AddAdditionalCost: "添加額外成本",
        AddCost: "添加成本",
        TotalPrice: "總價",
        SelectCharges: "選擇費用",
        EnterEstimatedCost: "輸入估計成本",
        QtyRequried: "所需數量",
        Manufacturing: "製造",
        Outputfinishedgoodsdestination: "成品目的地",
        Manufacturingquantity: "製造數量",
        Storefinishedgoodsat: "將成品存放在",
        Rawmaterials: "原材料",
        StockSelection: "庫存選擇",
        AdditionalCosts: "額外成本",
        Quantityconsume: "消耗數量",
        Totalmanufacturingcost: "總制造成本",
        Sumofrawmaterialcosts: "所有原材料成本的總和",
        CustomManufacturingCharge: "自定義製造費用",
        Addextralikelaboroverheadrepairs: "添加額外費用，如人工、間接費用或維修。",
        CalculatedTotal: "計算總額",
        AddRawMaterial: "添加原材料",
        ConfigureRawMaterial: "配置原材料",
        Thisoutputunit: "這是每單位產出所需的基礎數量。",
        ChangeProduct: "更換產品",
        AddtoList: "添加到列表",
        ManufacturedSuccessfully: "製造成功",
        Manufacture: "生產",
        EditDeleteHistory: "編輯/刪除記錄",
        ManageOrder: "管理訂單",
        ManageBatch: "管理批次",
        Paymentnotavailablehere: "此處無法付款",
        Thisrecordisanorderorderitself: "此記錄來自訂單。只能從訂單本身記錄付款。",
        Torecorpaymenttheorderthethere: "要記錄付款，請前往關聯訂單並在那裡使用<b>記錄付款</b>選項。",
        GotoOrder: "轉到訂單"
    },
    CustomerExcel: {
        title: "上傳客戶",
        description: "按照以下步驟使用 Excel 檔案批量建立客戶。",
        bulkUploadGuide: "批量上傳指南",
        step1: "第 1 步",
        downloadTemplate: "下載 Excel 範本",
        downloadTemplateDesc: "獲取預先配置了所有必需欄位標題的官方範本。",
        downloadTemplateBtn: "下載範本",
        step2: "第 2 步",
        fillExcelFile: "填寫 Excel 檔案",
        fillExcelDesc: "每一列代表一個客戶。按要求填寫所有欄位。",
        step3: "第 3 步",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "上傳前，請確保您的檔案遵循這些規則以避免錯誤。",
        step4: "第 4 步",
        uploadYourFile: "上傳您的檔案",
        uploadDesc: "填寫完成後，在下方上傳檔案。系統將自動建立所有客戶。",
        rules: [
            "每列僅限一個客戶",
            "請勿重新命名欄位標題",
            "帶國家代碼的聯絡電話",
            "僅接受 .xlsx 或 .xls 檔案"
        ],
        dropFileHere: "將 Excel 檔案拖放到此處",
        supports: "支援 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "選擇檔案並上傳",
        parsing: "正在解析檔案...",
        invalidFileType: "檔案類型無效。請上傳 Excel 檔案。",
        noData: "在 Excel 中未找到資料",
        failedToRead: "讀取 Excel 檔案失敗",
        unableToRead: "無法讀取檔案。",
        reviewTitle: "審核客戶資料",
        reviewSubtitle: "匯入您的業務前的最後檢查。",
        changeFile: "更改檔案",
        rowsFound: "在檔案中找到列",
        cancel: "取消",
        finalizeImport: "完成並匯入",
        importing: "正在匯入...",
        success: "成功",
        allCustomerUploadedSuccess: "所有客戶已成功上傳",
        failed: "失敗",
        bulkUploadFailed: "批量上傳失敗",
        error: "錯誤",
        headers: {
            customerName: "客戶名稱",
            phoneNumber: "聯絡方式",
            address: "地址",
            note: "備註"
        }
    },
    SupplierExcel: {
        title: "上傳供應商",
        description: "按照以下步驟使用 Excel 檔案批量建立供應商。",
        bulkUploadGuide: "批量上傳指南",
        step1: "第 1 步",
        downloadTemplate: "下載 Excel 範本",
        downloadTemplateDesc: "獲取預先配置了所有必需欄位標題的官方範本。",
        downloadTemplateBtn: "下載範本",
        step2: "第 2 步",
        fillExcelFile: "填寫 Excel 檔案",
        fillExcelDesc: "每一列代表一個供應商。按要求填寫所有欄位。",
        step3: "第 3 步",
        thingsToKeepInMind: "注意事項",
        rulesDesc: "上傳前，請確保您的檔案遵循這些規則以避免錯誤。",
        step4: "第 4 步",
        uploadYourFile: "上傳您的檔案",
        uploadDesc: "填寫完成後，在下方上傳檔案。系統將自動建立所有供應商。",
        rules: [
            "每列僅限一個供應商",
            "請勿重新命名欄位標題",
            "帶國家代碼的聯絡電話",
            "僅接受 .xlsx 或 .xls 檔案"
        ],
        dropFileHere: "將 Excel 檔案拖放到此處",
        supports: "支援 .xlsx 和 .xls — 最大 10 MB",
        chooseFileUpload: "選擇檔案並上傳",
        parsing: "正在解析檔案...",
        invalidFileType: "檔案類型無效。請上传 Excel 檔案。",
        noData: "在 Excel 中未找到資料",
        failedToRead: "讀取 Excel 檔案失敗",
        unableToRead: "無法讀取檔案。",
        reviewTitle: "審核供應商資料",
        reviewSubtitle: "匯入您的業務前的最後檢查。",
        changeFile: "更改檔案",
        rowsFound: "在檔案中找到列",
        cancel: "取消",
        finalizeImport: "完成並匯入",
        importing: "正在匯入...",
        success: "成功",
        allSupplierUploadedSuccess: "所有供應商已成功上傳",
        failed: "失敗",
        bulkUploadFailed: "批量上傳失敗",
        error: "錯誤",
        headers: {
            supplierName: "供應商名稱",
            phoneNumber: "聯絡方式",
            bankName: "銀行名稱",
            accountHolderName: "帳戶持有人姓名",
            accountNumber: "帳號",
            note: "備註"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "更換為",
        Noreplacementhistoryfound: "未找到更換記錄",
        Noreturnhistoryfound: "未找到退換貨記錄",
        Productbeingreturned: "退回的產品",
        Required: "必填",
        Selectreturnedproduct: "選擇退回的產品",
        Searchnamescanbarcode: "按名稱、SKU 搜尋或掃描條碼",
        Browse: "瀏覽",
        Stockhandling: "入庫處理",
        Stockinreturnedproduct: "將退回產品入庫",
        Ontoinventory: "開啟 — 退回物品將重新添加至庫存",
        Offreturnedonly: "關閉 — 物品僅記錄為退回",
        Usedrestock: "用於計算補貨時的利潤調整",
        Willaddedbackconfirmation: "確認後將重新添加至庫存",
        Returnreason: "退貨原因",
        Optional: "選填",
        SelectReason: "選擇原因",
        Additionalnotes: "補充備註",
        Describeofcustomerexplanation: "描述退回物品的狀態、任何明顯的損壞、客戶的解釋等...",
        Requiredmustfilledcontinue: "必須填寫必填欄位才能繼續",
        Reviewdetailsbeforeconfirming: "確認前請檢查詳情",
        Replacementproductwilldeductedinventoryconfirmation: "確認後，更換產品將從您的庫存中扣除。",
        Choosereplacementproduct: "選擇更換產品",
        Willdeductedfrominventoryconfirm: "確認後將從庫存中扣除",
        Thesewillattachedothereturnrecord: "這些圖片將附在退貨記錄中",
        Replacementitem: "更換物品",
        Addanotherproduct: "新增另一個產品",
        Replacementproductwillbe: "更換產品將在確認後",
        deducted: "扣除",
        fromyourinventoryconfirmation: "自您的庫存中。",
        productadjustedusingprice: "退回的產品將重新入庫，並使用原銷售價格調整利潤。",
        Willloggedreturnedonlynotrestocked: "僅記錄為退回 — 不重新入庫",
        Returnonly: "僅退貨",
        Imagesofreturnedproduct: "退回產品的圖片",
        Returnedproductwill: "退回的產品",
        not: "不會",
        berestockedloggedreturnedonly: "重新入庫 — 僅記錄為退回。",
        AddImage: "新增圖片",
        STOCKIN: "入庫",
        LOGONLY: "僅記錄",
        ContinuetoReview: "繼續檢查 →",
        Confirmreplacement: "確認更換",
        Confirmreturn: "確認退貨",
        Filldetailsbelowproceed: "請填寫以下詳情以繼續",
        Review: "檢查",
        editdetails: "編輯詳情",
        Configurereturndetails: "配置退貨詳情",
        Configurereplacementdetails: "配置更換詳情",
        SelectSource: "選擇來源",
        Returning: "退貨中",
        Replacement: "更換",
        WalkCustomer: "散客",
        RETURNEDPRODUCT: "退回產品",
        REPLACEMENTPRODUCT: "更換產品",
        STOCKOUT: "出庫",
        Netinventoryimpact: "淨庫存影響",
        Replacementitemcost: "更換物品成本",
        Returneditemrestockvalue: "退回物品入庫價值",
        PROFITINVENTORYSUMMARY: "利潤與庫存摘要",
        Inventoryaction: "庫存操作",
        Valuededucted: "扣除價值",
        Profitadjustment: "利潤調整",
        stockedout: " 已出庫",
        restocked: " 已入庫",
        Noaction: "無操作",
        Valuebeingreturned: "退回價值",
        Willberestocked: "將入庫",
        Willbe: "將",
        logged: "記錄",
        ON: "開啟",
        OFF: "關閉",
        Linked: "已連結",
        Pleaseselectreturnedproduct: "請選擇退貨產品",
        Quantityrequired: "數量為必填",
        Buyingpricerequired: "購買價為必填",
        Pleaseaddleastreplacementproduct: "請至少新增一個替換產品",
        Pleaseconfigurereturnedproductdetails: "請配置退貨產品詳情",
        Pleaseselectcustomer: "請選擇客戶",
        Returndateisrequired: "退貨日期為必填",
        Pleasefillallrequiredfields: "請填寫所有必填欄位",
        Wildeductedfrominventory: "將從庫存中扣除",
        Currentprice: "現時價格",
        Defectivedamaged: "有缺陷 / 損壞",
        Wrongitemreceived: "收到錯誤貨品",
        Customerchangedmind: "顧客改變主意",
        Sizefitissue: "尺寸 / 合身問題",
        Notasdescribed: "與描述不符",
        Other: "其他",
        Originalsaleprice: "原售價（利潤調整）",
        Addedbackinventory: "已加回庫存",
        Notaddedinventory: "未加入庫存",
        replacedwith: "更換為",
        deductedfrominventory: "從庫存扣除",
        RETURNWITHSTOCKIN: "退貨 · 有入庫",
        RETURNNOSTOCKIN: "退貨 · 無入庫",
        MULTIPLEREPLACEMENTS: "多次更換",
        SINGLEREPLACEMENT: "單次更換",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "已退 · 庫存入",
        REPLACEMENTSTOCKOUT: "更換 · 庫存出",
        Returnonlylogsthisentry: "退貨僅記錄此條目 —",
        nostockwillbeaddedorremoved: "不會增加或移除庫存",
        frominventory: "從庫存中。",
        Whentousethis: "何時使用此功能：",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "在一天結束時使用「僅退貨」來記錄因銷售而發出的物品，但在退回時已損壞或無法使用 — 您想要跟踪但無法重新加入庫存的物品。",
        Youcanviewallpastreturnentriesin: "您可以在以下位置查看所有過去的退換貨記錄：",
        ReturnHistory: "退貨歷史",
        underthe: "在",
        Others: "其他",
        tab: "選項卡下。"
    },
    NewRLocal: {
        Originalsaleprice: "原始銷售價格",
        Editinghistoryonlyinventorystaysunchanged: "僅編輯歷史記錄 — 庫存保持不變。",
        Changeshereupdatethisdetailsquantitiesaffected: "此處的更改僅更新此記錄的詳細資訊（原因、日期、備註）。您的實際庫存數量、貨位和產品數據不會受到影響。",
        Needtofixinventorylevelsinstead: "需要改為修正庫存水平嗎？",
        AdjustStock: "調整庫存",
        Refund: "退款",
        ImportantNote: "重要提示",
        Pleasereviewbeforecontinuing: "請在繼續之前查看",
        Onceshippedreceivedanyupdatesmadeorder: "訂單一旦出貨或接收，對訂單所做的任何更新都不會反映在交易歷史記錄中。",
        Thisundone: "這將永久移除訂單。此操作無法撤銷。",
        Inventorywilladjustedautomatically: "庫存不會自動調整",
        Deletingthisreversevedshippedyouwillneed: "刪除此操作不會撤銷任何庫存更改。如果物品已接收/出貨，您將需要",
        reflectthecorrectstocklevels: "以反映正確的庫存水平。",
        manuallyadjustyourinventory: "手動調整您的庫存",
        Addremovestockforitemsthatwereshipped: "為已出貨物品添加/移除庫存",
        Addremovestockforitemsthatwerereceived: "為已接收物品添加/移除庫存",
        Updatecostrecordspaymentwaalreadymade: "如果已付款，請更新成本記錄",
        Reconcilerecordsandoutstandingpayments: "核對記錄和未付賬款"
    },
    ReceivablesLocal: {
        Receivables: "應收賬款",
        Manageandtrackcustomerduebalances: "管理及追蹤客戶到期結餘",
        Viewcustomerduebalancereport: "檢視客戶到期結餘報告",
        Viewsupplierduebalancereport: "檢視供應商到期結餘報告",
        DueBalance: "到期結餘",
        Unpaid: "未付款",
        PartiallyPaid: "部分付款",
        Paid: "已付款",
        HighestBalance: "最高結餘",
        LowestBalance: "最低結餘",
        Filldetailsrecordpayment: "填寫詳細資料以記錄付款",
        NewPaymentEntry: "新增付款記錄",
        EditPaymentEntry: "編輯付款記錄",
        Nosuppliersfound: "未找到供應商",
        Nocustomersfound: "未找到客戶",
        LowtoHigh: "低至高",
        HightoLow: "高至低",
        AttachmentUploadedSc: "附件上傳成功",
        AttachmentUploadedF: "附件上傳失敗",
        Pay: "付款",
        NoBillsFound: "未找到賬單",
        Thiscustomerhasunpaidbills: "此客戶沒有未付賬單。",
        TotalDue: "總計到期",
        BillsFound: "找到賬單",
        DeselectAll: "取消全選",
        SelectAll: "全選",
        ShowDetails: "顯示詳情"
    },
    AssetsNewLocal: {
        Assignedon: "分配於",
        Total: "總計",
        Assigned: "已分配",
        Remaining: "剩餘",
        Available: "可用",
        NoSerialNumbers: "無序列號",
        UpdateExistingAssetDetails: "更新現有資產詳情",
        RegisterNewBusinessAsset: "註冊新的業務資產",
        BasicInformation: "基本信息",
        AssetDetails: "資產詳情",
        Quantity: "數量",
        SerialNumbers: "序列號",
        SerialNumberPlaceholder: "序列號",
        AddSerialNumber: "添加序列號",
        SerialNumbersOptional: "序列號為選填項。您最多可以添加",
        AssetImages: "資產圖片",
        AdditionalNotes: "備註",
        AdditionalNotesPlaceholder: "任何其他詳情或維護歷史...",
        Updating: "更新中...",
        Adding: "添加中...",
        ITEquipmentPlaceholder: "例如：IT設備",
        LoadingMoreActivities: "正在加載更多活動...",
        AssignedAssets: "已分配資產",
        Noassetsassignedstaffmember: "此員工沒有分配任何資產。",
        Assignassetstaff: "分配資產給員工",
        Returnassetfromstaff: "從員工處歸還此資產",
        AssignmentDetails: "分配詳情",
        Serial: "序列號",
        ViewAssets: "查看所有資產",
        ViewByStaff: "按員工查看",
        AssignedHistory: "分配歷史",
        Returned: "已歸還",
        Returnedon: "歸還日期",
        ReturnedBy: "歸還人",
        AssignedTo: "分配給",
        NoHistoryRecords: "沒有歷史記錄",
        Selectstaffmemberviewtheirassets: "選擇員工以查看其資產",
        Deleted: "已刪除",
        searchPlaceholder: "按名稱或序號搜尋資產..."
    },
    InventoryCountLocale: {
        InventoryCount: "庫存盤點",
        Viewinventorycountreport: "查看庫存盤點報告",
        ItemsCount: "貨品數量",
        All: "全部",
        InProgress: "進行中",
        Submitted: "已提交",
        awaitingreview: "等待審核",
        EditInventoryCount: "編輯盤點",
        NewInventoryCount: "新增盤點",
        Modifyinventorycountsheetdetails: "修改盤點表詳情",
        Startanewinventorycountsheet: "開始新的盤點表",
        GeneralInformation: "基本資料",
        Title: "標題",
        SaveChanges: "儲存變更",
        Selectproductsforthisinventorycountsheet: "選擇本次盤點的產品",
        InventoryCountDetails: "盤點詳情",
        Inventorycountsheetdetails: "盤點表詳情",
        Viewingdetailsforcountsheet: "正在查看盤點表詳情",
        Started: "已開始",
        TaskSheets: "任務表",
        Allitems: "所有貨品",
        NotStarted: "未開始",
        Completed: "已完成",
        Results: "結果",
        ViewResults: "查看結果",
        DeleteInventoryCount: "刪除盤點",
        Viewingtransactionandadjustments: "查看交易記錄和庫存調整",
        Productsadjusted: "已調整產品",
        Assignee: "負責人",
        Tasksheetdetails: "任務表詳情",
        Draft: "草稿",
        VariantQuantities: "變體數量",
        AssignedProducts: "已分配產品",
        ReturnAsset: "歸還資產",
        EditTasksheet: "編輯任務表",
        NewTasksheet: "新增任務表",
        Updatetasksheetdetails: "更新任務表詳情",
        Starttasksheetforthisinventorycount: "為此盤點開始新的任務表",
        TaskSheetInformation: "任務表資料",
        SheetTitle: "表格標題",
        Entersheettitle: "輸入表格標題",
        SubmissionResult: "提交結果",
        ReviewChanges: "審核變更",
        Viewingsubmissionresultsforthisinventorycount: "查看此盤點的提交結果",
        Reviewyourinventorycountbeforesubmitting: "提交前請檢查您的庫存盤點"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "載入盤點失敗",
        NoInventoryCounts: "沒有庫存盤點",
        NoMatches: "沒有匹配項",
        Therearenoinventorycountswiththestatus: "沒有此狀態的庫存盤點",
        Noinventorycountsfoundyoursearchterm: "未找到符合您搜尋字詞的庫存盤點",
        Thereareinventorycountsrecordedyetforthisbusiness: "此業務尚未記錄任何庫存盤點"
    },
    StockinModalP: {
        StockInNow: "立即入庫",
        Settheopeningquantityforthisproductrightnow: "立即設定此產品的初始數量。",
        Addinitialstock: "新增初始庫存？",
        dothislater: "稍後再做",
        Productadded: "商品新增成功！",
        isready: "已就緒。",
        SeeHowItWorks: "查看運作方式",
        NoSalesOrdersFound: "未找到銷售訂單",
        NoPurchaseOrdersFound: "未找到採購訂單",
        Startcreatingoutgoinginventoryrevenue: "開始建立銷售訂單以追蹤出庫庫存和收入。",
        Trackrestockssupplierplace: "在一個地方追蹤庫存補貨和供應商訂單。",
        CreateSalesOrder: "建立銷售訂單",
        CreatePurchaseOrder: "建立採購訂單",
    }
    ,
    dialy_report: "每日變動報告",
    Quotation: "報價",
    Quote: "報價",
    Assignee: "負責人",
    dayStart: "一日開始",

    ShowTotalAmount: "總金額",


    tutorial: {
        watchTitle: '觀看逐步教學課程',
        watchDesc: '在我們的YouTube頻道上學習SimplyStock',
        modalTitle: '使用SimplyStock保持領先地位',
        modalDesc: '訂閱即可在新教程下載時獲得新教程',
        feature1Title: '全新功能逐步解說',
        feature1Sub: '每次更新都會透過簡短影片進行說明，讓您永遠不會錯過新功能',
        feature2Title: '快速操作影片',
        feature2Sub: '在5分鐘內設定庫存、發票、員工存取權限等',
        feature3Title: '即時通知',
        feature3Sub: '在新教程上線時獲得通知—按照自己的步調學習',
        feature4Title: '完全免費，永久免費',
        feature4Sub: '所有教程都是永久免費的—無需登入或訂閱',
        subscribeBtn: '訂閱SimplyStock',
        maybeLater: '稍後'
    }
    ,
    dailyCashReport: {
        "title": "每日現金報表",
        "subtitle": "誰在什麼日期支付了什麼，還有什麼未付 — 根據銷售明細匯總。",
        "totalSales": "總銷售額",
        "cashReceived": "總共收到",
        "outstanding": "未結清",
        "collectionRate": "收款率",
        "grandTotalAllDates": "總計（所有日期）",
        "totalLabel": "總計",
        "loading": "載入中...",
        "noData": "找不到選定日期範圍的數據。",
        "loadingMore": "載入更多..."
    },
    dailyCashReportColumns: {
        "date": "日期",
        "customer": "客戶",
        "productsSold": "售出產品",
        "products": "產品",
        "salesAmount": "銷售金額",
        "sales": "銷售",
        "received": "總共收到",
        "receivedShort": "已收",
        "debited": "借記到分類帳",
        "due": "應付",
        "paymentModes": "支付方式",
        "mode": "方式"
    }

}

export default zh_HK
